import Vue from "vue";
import Router from "vue-router";
import DashboardLayout from "@/layout/DashboardLayout";
import AdminLayout from "@/layout/AdminLayout";
import InheritLayout from "@/layout/InheritLayout";
import AuthLayout from "@/layout/AuthLayout";
import ContentLayout from "@/layout/Content";
import PaymentLayout from "@/layout/PaymentLayout";
import i18n from "../plugins/i18n";
import AppConfig from "../constants/AppConfig";
import { store } from "../store/store.js";

Vue.use(Router);

const router = new Router({
  linkExactActiveClass: "exact-active",
  linkActiveClass: "active",
  mode: "history",
  routes: [
    {
      path: "/payment-prestation/:id",
      name: "payment-prestation",
      component: PaymentLayout,
      children: [
        {
          path: "",
          name: "checkout",
          component: () => import("../views/Payment/checkout.vue"),
        },
        {
          path: "/payment-prestation/success/:id",
          name: "PaymentSuccess",
          component: () => import("../views/Payment/helpers/success.vue"),
        },
        {
          path: "/payment-prestation/failed/:id",
          name: "FailedPayment",
          component: () => import("../views/Payment/helpers/failed.vue"),
        },
        {
          path: "/om/paiement/:pay_token/notification",
          name: "prestation-om-notification",
          component: () =>
            import("../views/Paiement/OMPrestationNotification.vue"),
          meta: {
            //  title: i18n.t('message.add') + ' ' + i18n.tc('message.notification', 1),
          },
        },
      ],
    },
    {
      path: "/dashboard",
      redirect: "dashboard",
      component: DashboardLayout,
      children: [
        {
          path: "",
          name: "dashboard",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "demo" */ "../views/Dashboard.vue"),
          meta: {
            //requiresAuth: true,
            title: i18n.t("message.dashboard"),
            //     breadcrumbs: [
            //         { text: i18n.t('message.dashboard'), active: true }
            //     ]
          },
        },
        {
          path: "/setting",
          name: "/setting",

          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "../views/Passwords/Update.vue"
            ),
          meta: {
            //requiresAuth: true,
            title: i18n.t("message.settings"),
            //     breadcrumbs: [
            //         { text: i18n.t('message.dashboard'), active: true }
            //     ]
          },
        },
        {
          path: "/signature",
          name: "/signature",
          component: () => import("../views/Passwords/Signature.vue"),
          meta: {
            title: i18n.t("message.signature"),
          },
        },
        {
          path: "/notifications",
          name: "notifications",
          component: () => import("../views/Notifications/Notifications.vue"),
          meta: {
            title: i18n.t("Notifications"),
          },
        },
        {
          path: "/alertes",
          name: "alertes",
          component: () => import("../views/Alerte/Alerte.vue"),
          meta: {
            title: i18n.t("Alertes"),
          },
        },
        {
          path: "/alertes?uuid=:uuid",
          name: "alerte",
          component: () => import("../views/Alerte/Alerte.vue"),
          meta: {
            title: i18n.t("Alertes"),
          },
          props: true,
        },

        {
          path: "gestion-patient",
          redirect: "gestion-patient",
          component: InheritLayout,
          children: [
            {
              path: "",
              name: "gestion-patient",
              component: () => import("../views/Patiens.vue"),
              meta: {
                title: i18n.tc("message.gestionPatient", 2),
              },
            },
          ],
        },
        {
          path: "/speech",
          name: "/speech",

          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "demo" */ "../views/SpeechTestVue.vue"),
          meta: {
            //requiresAuth: true,
            title: "Speech",
            //     breadcrumbs: [
            //         { text: i18n.t('message.dashboard'), active: true }
            //     ]
          },
        },
        {
          path: "/practioner-dashboard",
          name: "PractionerDashboard",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "../views/Dashboard/PractionerDashboard.vue"
            ),
          meta: {
            //requiresAuth: true,
            title: i18n.t("message.practionerDashboard"),
            //     breadcrumbs: [
            //         { text: i18n.t('message.practionerDashboard'), active: true }
            //     ]
          },
        },
        {
          path: "/suivies-dossier",
          name: "MedecinPatient",
          component: () => import("../views/MedecinPatient/List.vue"),
          meta: {
            title: i18n.t("message.medecinPatient"),
          },
        },
        {
          path: "/appointments",
          redirect: "appointments",
          component: InheritLayout,
          children: [
            {
              path: "/",
              name: "appointments",
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () =>
                import(
                  /* webpackChunkName: "demo" */ "../views/Appointments/Appointments.vue"
                ),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.appointments"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.practionerDashboard'), active: true }
                //     ]
              },
            },
            {
              path: "/appointments/more-appointments",
              name: "more-appointments",
              component: () =>
                import("../views/Appointments/MoreAppointments.vue"),
              meta: {
                //requiresAuth: true,
                title: i18n.tc("message.Trajet", 2),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                //         { text: i18n.tc('message.medicalFiles', 2), active: true }
                //     ]
              },
            },
          ],
        },
        {
          path: "/validation",
          redirect: "validations",
          component: AdminLayout,
          children: [
            {
              path: "/",
              name: "validations",
              component: () =>
                import("../views/Validation/ValidationExamen.vue"),
              meta: {
                title: i18n.t("message.validations"),
              },
            },
            {
              path: "/validations-prix",
              name: "validations-prix",
              component: () =>
                import("../views/Validation/ValidationSouscripteur.vue"),
              meta: {
                title: i18n.t("message.validations"),
              },
            },
            {
              path: "/examen-validation-prix",
              name: "examen-validation-prix",
              component: () => import("../views/Validation/Facture.vue"),
              meta: {
                title: i18n.t("message.validations"),
              },
            },
            {
              path: "/examens",
              name: "examens",
              component: () =>
                import("../views/Validation/ValidationSouscripteur.vue"),
              meta: {
                title: i18n.t("message.validations"),
              },
            },
          ],
        },
        {
          path: "historique",
          name: "mes-patients",
          component: () => import("../views/MedicalFiles/MyMedicalFile.vue"),
        },
        {
          path: "/assurances/contact",
          name: "prospect-assurances",
          component: () => import("../views/Assurances/List.vue"),
        },
        {
          path: "/follow-up",
          redirect: "follow-up",
          component: InheritLayout,
          children: [
            {
              path: "/",
              name: "follow-up",
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () =>
                import(
                  /* webpackChunkName: "demo" */ "../views/FollowUpCategory/FollowUpCategories.vue"
                ),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.followUp"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.practionerDashboard'), active: true }
                //     ]
              },
            },
            {
              path: ":followUpCategorySlug",
              name: "follow-up-category",
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () =>
                import(
                  /* webpackChunkName: "demo" */ "../views/FollowUpCategory/FollowUpCategory.vue"
                ),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.followUp"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.practionerDashboard'), active: true }
                //     ]
              },
            },
            {
              path: "medecin-to-patient",
              name: "medecin-to-patient",
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () =>
                import(
                  /* webpackChunkName: "demo" */ "../views/FollowUpCategory/PatientMedecin.vue"
                ),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.followUp"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.practionerDashboard'), active: true }
                //     ]
              },
            },
            {
              path: "add",
              name: "add-follow-up",
              component: () => import("../views/FollowUp/AddFollowUp.vue"),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.addFollowUp"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                //         { text: i18n.t('message.add'), active: true }
                //     ]
              },
            },
            {
              path: ":followedUp/edit",
              name: "edit-follow-up",
              component: () => import("../views/FollowUp/EditFollowUp.vue"),
              meta: {
                //requiresAuth: true,
                title:
                  i18n.t("message.edit") + " " + i18n.t("message.followUp"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                //         { text: i18n.t('message.add'), active: true }
                //     ]
              },
            },
          ],
        },
        // {
        //     path:'/follow-up-souscripteur',
        //     redirect: 'follow-up-souscripteur',
        //     component: InheritLayout,
        //     children: [
        //         {
        //             path: '/',
        //             name: 'follow-up-souscripteur',
        //             component: () => import( '../views/Subscribers/SubscribersCim.vue'),
        //             meta: {
        //                 title: i18n.t('message.followUpSouscripteur', 2),
        //             }
        //         }
        //     ],
        // },
        {
          path: "/add-afflitation-from-ama",
          redirect: "add-afflitation-from-ama",
          component: InheritLayout,
          children: [
            {
              path: "/",
              name: "add-afflitation-from-ama",
              component: () => import("../views/Assistant/AddAffiliation.vue"),
              meta: {
                title: "Nouvelle affiliation",
              },
            },
          ],
        },
        {
          path: "/edit-afflitation-from-ama",
          redirect: "edit-afflitation-from-ama",
          component: InheritLayout,
          children: [
            {
              path: "/edit-afflitation-from-ama/:contrat/:patient_label/:souscripteur_label",
              name: "edit-afflitation-from-ama",
              component: () => import("../views/Assistant/EditAffiliation.vue"),
              meta: {
                title: i18n.t("message.editAffiliation"),
              },
            },
          ],
        },

        {
          path: "/souscripteur-medicasure",
          redirect: "souscripteur-medicasure",
          component: InheritLayout,
          children: [
            {
              path: "/",
              name: "souscripteur-medicasure",
              component: () =>
                import("../views/Subscribers/SubcribersMedicasure.vue"),
              meta: {
                title: i18n.t("message.followUpSouscripteur", 2),
              },
            },
          ],
        },
        {
          path: "/medical-advice",
          redirect: "medical-advice",
          component: InheritLayout,
          children: [
            {
              path: "/",
              name: "medical-advice",
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () =>
                import(
                  /* webpackChunkName: "demo" */ "../views/MedicalAdvice/MedicalAdvice.vue"
                ),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.medicalAdvice"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.practionerDashboard'), active: true }
                //     ]
              },
            },
            {
              path: "add",
              name: "add-medical-advice",
              component: () =>
                import("../views/MedicalAdvice/AddMedicalAdvice.vue"),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.addMedicalAdvice"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                //         { text: i18n.t('message.add'), active: true }
                //     ]
              },
            },
            {
              path: ":medicalAdviceSlug/edit",
              name: "edit-medical-advice",
              component: () =>
                import("../views/MedicalAdvice/EditMedicalAdvice.vue"),
              meta: {
                //requiresAuth: true,
                title:
                  i18n.t("message.edit") +
                  " " +
                  i18n.t("message.medicalAdvice"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                //         { text: i18n.t('message.add'), active: true }
                //     ]
              },
            },
            {
              path: ":medicalAdviceSlug/show",
              name: "show-medical-advice",
              component: () =>
                import("../views/MedicalAdvice/ShowMedicalAdvice.vue"),
              meta: {
                //requiresAuth: true,
                title:
                  i18n.t("message.show") +
                  " " +
                  i18n.t("message.medicalAdvice"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                //         { text: i18n.t('message.add'), active: true }
                //     ]
              },
            },
            {
              path: ":medicalAdviceSlug/response",
              name: "response-medical-advice",
              component: () =>
                import("../views/MedicalAdvice/ResponseMedicalAdvice.vue"),
              meta: {
                //requiresAuth: true,
                title:
                  i18n.t("message.response") +
                  " " +
                  i18n.t("message.medicalAdvice"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                //         { text: i18n.t('message.add'), active: true }
                //     ]
              },
            },
            {
              path: ":medicalAdviceSlug/response/:doctorAdviceSlug/edit",
              name: "edit-response-medical-advice",
              component: () =>
                import("../views/MedicalAdvice/EditResponseMedicalAdvice.vue"),
              meta: {
                //requiresAuth: true,
                title:
                  i18n.t("message.edit") +
                  " " +
                  i18n.t("message.response") +
                  " " +
                  i18n.t("message.medicalAdvice"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                //         { text: i18n.t('message.add'), active: true }
                //     ]
              },
            },
          ],
        },
        {
          path: "medecin-dashboard",
          name: "MedecinDashboard",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "../views/Dashboard/MedecinDashboard.vue"
            ),
          meta: {
            //requiresAuth: true,
            title: i18n.t("message.dashboard"),
            //     breadcrumbs: [
            //         { text: i18n.t('message.dashboard'), active: true }
            //     ]
          },
        },
        {
          path: "/assistante-dashboard",
          name: "AssistanteDashboard",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "../views/Dashboard/AssistanteDashboard.vue"
            ),
          meta: {
            //requiresAuth: true,
            title: i18n.t("message.dashboard"),
            //     breadcrumbs: [
            //         { text: i18n.t('message.dashboard'), active: true }
            //     ]
          },
        },
        {
          path: "/dashboard-metrique",
          name: "DashboardMetrique",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "../views/Dashboard/DashboardMetrique.vue"
            ),
          meta: {
            //requiresAuth: true,
            title: i18n.t("message.Metrique"),
            //     breadcrumbs: [
            //         { text: i18n.t('message.dashboard'), active: true }
            //     ]
          },
        },
        {
          path: "/prise-charge",
          name: "PriseEnCharge",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "../views/PriseEnCharge/List.vue"
            ),
          meta: {
            //requiresAuth: true,
            title: i18n.t("message.takeCare"),
            //     breadcrumbs: [
            //         { text: i18n.t('message.dashboard'), active: true }
            //     ]
          },
        },
        {
          path: "/prise-charge/:metrique",
          name: "PriseEnChargeDetail",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "../views/PriseEnCharge/Detail.vue"
            ),
          meta: {
            //requiresAuth: true,
            title: i18n.t("message.takeCareMetrique"),
            //     breadcrumbs: [
            //         { text: i18n.t('message.dashboard'), active: true }
            //     ]
          },
        },
        {
          path: "/prise-charge/evolutions/:metrique",
          name: "PriseEnChargeEvolution",
          component: () => import("../views/PriseEnCharge/EvolutionUser.vue"),
          meta: {
            title: i18n.t("message.takeCareMetrique"),
          },
        },
        {
          path: "activite-management",
          redirect: "activite-management",
          component: AdminLayout,
          children: [
            {
              path: "",
              name: "activite-management",
              component: () => import("../views/ActiviteManagement.vue"),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.activiteManagement"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.userManagement'), active: true }
                //     ]
              },
            },
            {
              path: "/affiliation/:contrat",
              name: "affiliation",
              component: () =>
                import(
                  /* webpackChunkName: "demo" */ "../views/Subscribers/Affiliation.vue"
                ),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.donneesAffiliation"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), active: true }
                //     ]
              },
            },
            {
              path: "/follow-up-souscripteur",
              redirect: "follow-up-souscripteur",
              component: InheritLayout,
              children: [
                {
                  path: "/",
                  name: "follow-up-souscripteur",
                  component: () =>
                    import("../views/Subscribers/SubscribersCim.vue"),
                  meta: {
                    title: i18n.t("message.followUpSouscripteur", 2),
                  },
                },
              ],
            },
            {
              path: "/prospect",
              name: "prospect",
              component: () => import("../views/TrajetPatients/Prospect.vue"),
              meta: {
                //requiresAuth: true,
                title: i18n.tc("message.Prospects", 2),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                //         { text: i18n.tc('message.affiliations', 2), active: true }
                //     ]
              },
            },

            {
              path: "activites",
              redirect: "activites",
              component: InheritLayout,
              children: [
                {
                  path: "praticiens/activites",
                  name: "praticiens",
                  component: () => import("../views/Activites/Praticiens.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.practitioners", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.managers', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "medecin-referent",
                  name: "medecin-referent",
                  component: () =>
                    import("../views/Referent/MedecinControle.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.medecinreferent"),
                  },
                },
                {
                  path: "medecin-referent/add/activites",
                  name: "medecin-referent-activite",
                  component: () => import("../views/Referent/Add.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.add"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: "medecin-referent/create",
                  name: "create-activite-controle",
                  component: () => import("../views/Referent/create.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.add"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: "ama/mission",
                  name: "ama",
                  component: () => import("../views/Activites/Ama.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.ama", 2),
                  },
                },
                {
                  path: ":groupe/activite/add",
                  name: "add-activite",
                  component: () => import("../views/Activites/Add.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.add"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":groupe/activite/:activite/edit",
                  name: "edit-manager",
                  component: () => import("../views/Activites/Edit.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.activite.titre", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":groupe/activite/:activite",
                  name: "activite",
                  component: () => import("../views/Activites/Show.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.activite.titre", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                    //         { text: i18n.tc('message.managers', 1), active: true }
                    //     ]
                  },
                },
                {
                  path: "ama/mission/create-activite",
                  name: "create-activite",
                  component: () => import("../views/Activites/create.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.ajouterActivite"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: "ama/mission/create-pec",
                  name: "create-pec",
                  component: () => import("../views/Activites/pec.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.activite.titre", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
              ],
            },
          ],
        },
        {
          path: "user-management",
          redirect: "user-management",
          component: AdminLayout,
          children: [
            {
              path: "",
              name: "user-management",
              component: () => import("../views/UserManagement.vue"),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.userManagement"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.userManagement'), active: true }
                //     ]
              },
            },
            {
              path: "associations",
              redirect: "associations",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "associations",
                  component: () => import("../views/Association/List.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.associations", 2),
                  },
                },
                {
                  path: "add",
                  name: "add-association",
                  component: () => import("../views/Association/Add.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addAssociation"),
                  },
                },
                {
                  path: ":association/edit",
                  name: "edit-association",
                  component: () => import("../views/Association/Edit.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.association", 1),
                  },
                },
                {
                  path: ":association",
                  name: "association",
                  component: () => import("../views/Association/Show.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.association", 1),
                  },
                },
              ],
            },
            {
              path: "managers",
              redirect: "managers",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "managers",
                  component: () => import("../views/Managers/Managers.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.managers", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.managers', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-manager",
                  component: () => import("../views/Managers/AddManager.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.managers", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":manager/edit",
                  name: "edit-manager",
                  component: () => import("../views/Managers/EditManager.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.managers", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":manager",
                  name: "manager",
                  component: () => import("../views/Managers/Manager.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.managers", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.managers', 2), to: { name: 'managers' } },
                    //         { text: i18n.tc('message.managers', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "patients",
              redirect: "patients",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "patients",
                  component: () => import("../views/Patients/Patients.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.patients", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.patients', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-patient",
                  component: () => import("../views/Patients/AddPatient.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addPatient"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.patients', 2), to: { name: 'patients' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: "paiement/:identifiant",
                  name: "paiement",
                  component: () => import("../views/Paiement/Paiement.vue"),
                  meta: {
                    // title: i18n.t('message.add') + ' ' + i18n.tc('message.patients', 1),
                  },
                },
                {
                  path: "paiement-status/:identifiant",
                  name: "paiement",
                  component: () =>
                    import("../views/Paiement/PaiementStatus.vue"),
                  meta: {
                    // title: i18n.t('message.add') + ' ' + i18n.tc('message.patients', 1),
                  },
                },
                {
                  path: "paiement-cancel",
                  name: "paiement",
                  component: () =>
                    import("../views/Paiement/PaiementError.vue"),
                  meta: {
                    // title: i18n.t('message.add') + ' ' + i18n.tc('message.patients', 1),
                  },
                },
                {
                  path: "add-patient-souscripteur",
                  name: "add-patient-souscripteur",
                  component: () =>
                    import("../views/Subscribers/AddPatient.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addPatient"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.patients', 2), to: { name: 'patients' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: "add-patient-souscripteur",
                  name: "add-patient-souscripteur",
                  component: () =>
                    import("../views/Subscribers/firstaddpatient.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addPatient"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.patients', 2), to: { name: 'patients' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: "patient-medecin-controle",
                  name: "patient-medecin-controle",
                  component: () =>
                    import("../views/Patients/ListPatientMedecinControl.vue"),
                  meta: {
                    title: i18n.t("message.listMedecinControl"),
                  },
                },
                {
                  path: "changer-patient-medecin-controle",
                  name: "changer-patient-medecin-controle",
                  component: () =>
                    import("../views/Patients/ChangeMedecinPatient.vue"),
                  meta: {
                    title: i18n.t("message.listMedecinControl"),
                  },
                },
                {
                  path: "dashboard-patient-sans-intervention",
                  name: "PatientDashboardSansIntervention",
                  component: () =>
                    import("../views/Patients/ListPatientSansIntervention.vue"),
                  meta: {
                    title: i18n.t("message.listMedecinControl"),
                  },
                },
                {
                  path: ":patient/edit",
                  name: "edit-patient",
                  component: () => import("../views/Patients/EditPatient.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.patients", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.patients', 2), to: { name: 'patients' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":patient",
                  redirect: "patient",
                  component: InheritLayout,
                  children: [
                    {
                      path: "",
                      name: "patient",
                      component: () => import("../views/Patients/Patient.vue"),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.tc("message.patients", 1),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                        //         { text: i18n.tc('message.patients', 2), to: { name: 'patients' } },
                        //         { text: i18n.tc('message.patients', 1), active: true }
                        //     ]
                      },
                    },

                    {
                      path: "institutions/add",
                      name: "add-patient-institution",
                      component: () =>
                        import(
                          "../views/Patients/Institutions/AddInstitution.vue"
                        ),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.t("message.addInstitution"),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                        //         { text: i18n.tc('message.patients', 2), to: { name: 'patients' } },
                        //         { text: i18n.tc('message.patients', 1), to: { name: 'patient' } },
                        //         { text: i18n.tc('message.institutions', 2), active: true }
                        //     ]
                      },
                    },

                    {
                      path: "subscribers/add",
                      name: "add-patient-subscriber",
                      component: () =>
                        import(
                          "../views/Patients/Souscripteurs/AddSouscripteur.vue"
                        ),
                      meta: {
                        title: i18n.t("message.addSubscriber"),
                      },
                    },
                  ],
                },
              ],
            },
            {
              path: "control-doctors",
              redirect: "control-doctors",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "control-doctors",
                  component: () =>
                    import("../views/ControlDoctors/ControlDoctors.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.controlDoctors", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.controlDoctors', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-control-doctor",
                  component: () =>
                    import("../views/ControlDoctors/AddControlDoctor.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addControlDoctors"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.controlDoctors', 2), to: { name: 'control-doctors' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":doctor/edit",
                  name: "edit-control-doctor",
                  component: () =>
                    import("../views/ControlDoctors/EditControlDoctor.vue"),
                  // meta: {
                  //     //requiresAuth: true,
                  //     title: i18n.t('message.edit') + ' ' + i18n.tc('message.controlDoctors', 1),
                  //     breadcrumbs: [
                  //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                  //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                  //         { text: i18n.tc('message.controlDoctors', 2), to: { name: 'control-doctors' } },
                  //         { text: i18n.t('message.edit'), active: true }
                  //     ]
                  // }
                },
                {
                  path: ":doctor",
                  name: "control-doctor",
                  component: () =>
                    import("../views/ControlDoctors/ControlDoctor.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.controlDoctors", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.controlDoctors', 2), to: { name: 'control-doctors' } },
                    //         { text: i18n.tc('message.controlDoctors', 1), active: true }
                    //     ]
                  },
                },
                {
                  path: ":doctor/institutions/add",
                  name: "add-doctor-institution",
                  component: () =>
                    import(
                      "../views/ControlDoctors/Institutions/AddInstitution.vue"
                    ),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addInstitution"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.patients', 2), to: { name: 'patients' } },
                    //         { text: i18n.tc('message.patients', 1), to: { name: 'patient' } },
                    //         { text: i18n.tc('message.institutions', 2), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "practitioners",
              redirect: "practitioners",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "practitioners",
                  component: () =>
                    import("../views/Practitioners/Practitioners.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.practitioners", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.practitioners', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-practitioner",
                  component: () =>
                    import("../views/Practitioners/AddPractitioner.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addPractitioners"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.practitioners', 2), to: { name: 'practitioners' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":practitioner/edit",
                  name: "edit-practitioner",
                  component: () =>
                    import("../views/Practitioners/EditPractitioner.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.practitioners", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.practitioners', 2), to: { name: 'practitioners' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":practitioner",
                  name: "practitioner",
                  component: () =>
                    import("../views/Practitioners/Practitioner.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.practitioners", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.practitioners', 2), to: { name: 'practitioners' } },
                    //         { text: i18n.tc('message.practitioners', 1), active: true }
                    //     ]
                  },
                },
                {
                  path: ":praticien/institutions/add",
                  name: "add-praticien-institution",
                  component: () =>
                    import(
                      "../views/Practitioners/Institutions/AddInstitution.vue"
                    ),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addInstitution"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.patients', 2), to: { name: 'patients' } },
                    //         { text: i18n.tc('message.patients', 1), to: { name: 'patient' } },
                    //         { text: i18n.tc('message.institutions', 2), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "partner",
              redirect: "partner",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "partners",
                  component: () => import("../views/Partners/Partners.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.partners", 2),
                  },
                },
                {
                  path: "add",
                  name: "add-partner",
                  component: () => import("../views/Partners/AddPartner.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addPartners"),
                  },
                },
                {
                  path: ":partner/edit",
                  name: "edit-partner",
                  component: () => import("../views/Partners/EditPartner.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.Partners", 1),
                  },
                },
                {
                  path: ":partner",
                  name: "partner",
                  component: () => import("../views/Partners/Partner.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.Partners", 1),
                  },
                },
              ],
            },
            {
              path: "subscribers",
              redirect: "subscribers",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "subscribers",
                  component: () =>
                    import("../views/Subscribers/Subscribers.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.subscribers", 2),
                  },
                },

                {
                  path: "add",
                  name: "add-subscriber",
                  component: () =>
                    import("../views/Subscribers/AddSubscriber.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.subscribers", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.subscribers', 2), to: { name: 'subscribers' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":subscriber/edit",
                  name: "edit-subscriber",
                  component: () =>
                    import("../views/Subscribers/EditSubscriber.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.subscribers", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.subscribers', 2), to: { name: 'subscribers' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":subscriber",
                  name: "subscriber",
                  component: () =>
                    import("../views/Subscribers/Subscriber.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.subscribers", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.subscribers', 2), to: { name: 'subscribers' } },
                    //         { text: i18n.tc('message.subscribers', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "assistants",
              redirect: "assistants",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "assistants",
                  component: () => import("../views/Assistant/Assistants.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.assistante", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.patients', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-assistant",
                  component: () =>
                    import("../views/Assistant/AddAssistant.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.assistante", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.patients', 2), to: { name: 'patients' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":assistant/edit",
                  name: "edit-assistant",
                  component: () =>
                    import("../views/Assistant/EditAssistant.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.assistante", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":assistant",
                  name: "assistant",
                  component: () => import("../views/Assistant/Assistant.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.assistante", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.tc('message.affiliations', 1), active: true }
                    //     ]
                  },
                },
                {
                  path: "add-patient-souscripteur",
                  name: "add-patient-souscripteur",
                  component: () =>
                    import("../views/Subscribers/AddPatient.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addPatient"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.patients', 2), to: { name: 'patients' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: "patient-medecin-controle",
                  name: "patient-medecin-controle",
                  component: () =>
                    import("../views/Patients/ListPatientMedecinControl.vue"),
                  meta: {
                    title: `${i18n.t("message.list")} ${i18n.tc(
                      "message.patientMedecinControl",
                      1
                    )}`,
                  },
                },
                {
                  path: ":patient/edit",
                  name: "edit-patient",
                  component: () => import("../views/Patients/EditPatient.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.patients", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                    //         { text: i18n.tc('message.patients', 2), to: { name: 'patients' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":patient",
                  redirect: "patient",
                  component: InheritLayout,
                  children: [
                    {
                      path: "",
                      name: "patient",
                      component: () => import("../views/Patients/Patient.vue"),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.tc("message.patients", 1),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                        //         { text: i18n.tc('message.patients', 2), to: { name: 'patients' } },
                        //         { text: i18n.tc('message.patients', 1), active: true }
                        //     ]
                      },
                    },

                    {
                      path: "institutions/add",
                      name: "add-patient-institution",
                      component: () =>
                        import(
                          "../views/Patients/Institutions/AddInstitution.vue"
                        ),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.t("message.addInstitution"),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.userManagement'), to: { name: 'user-management' } },
                        //         { text: i18n.tc('message.patients', 2), to: { name: 'patients' } },
                        //         { text: i18n.tc('message.patients', 1), to: { name: 'patient' } },
                        //         { text: i18n.tc('message.institutions', 2), active: true }
                        //     ]
                      },
                    },

                    {
                      path: "subscribers/add",
                      name: "add-patient-subscriber",
                      component: () =>
                        import(
                          "../views/Patients/Souscripteurs/AddSouscripteur.vue"
                        ),
                      meta: {
                        title: `${i18n.t("message.add")} ${i18n.tc(
                          "message.subscribers",
                          1
                        )}`,
                      },
                    },
                  ],
                },
              ],
            },
            {
              path: "groupes",
              redirect: "groupes",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "groupes",
                  component: () => import("../views/Groupes/Groupes.vue"),
                  meta: {
                    title: i18n.tc("message.groupes", 2),
                  },
                },
                {
                  path: "create",
                  name: "create-groupe",
                  component: () => import("../views/Groupes/GroupeCreate.vue"),
                  meta: {
                    title: i18n.tc("message.add", 2),
                  },
                },
                {
                  path: ":uuid/show",
                  name: "show-groupe",
                  component: () => import("../views/Groupes/Groupe.vue"),
                  meta: {
                    title: i18n.tc("message.groupe", 2),
                  },
                },
                {
                  path: ":uuid/edit",
                  name: "edit-groupe",
                  component: () => import("../views/Groupes/GroupeCreate.vue"),
                  meta: {
                    title: i18n.tc("message.groupe", 2),
                  },
                },
              ],
            },
          ],
        },
        {
          path: "admin-management",
          redirect: "admin-management",
          component: AdminLayout,
          children: [
            {
              path: "",
              name: "admin-management",
              component: () => import("../views/AdminManagement.vue"),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.adminManagement"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.adminManagement'), active: true }
                //     ]
              },
            },
            {
              path: "medical-files",
              redirect: "medical-files",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "medical-files",
                  component: () =>
                    import("../views/MedicalFiles/MedicalFiles.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.medicalFiles", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.medicalFiles', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-medical-file",
                  component: () =>
                    import("../views/MedicalFiles/AddMedicalFile.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.medicalFiles", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.medicalFiles', 2), to: { name: 'medical-files' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":file/edit",
                  name: "edit-medical-file",
                  component: () =>
                    import("../views/MedicalFiles/EditMedicalFile.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.medicalFiles", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.medicalFiles', 2), to: { name: 'medical-files' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":file",
                  name: "medical-file",
                  component: () =>
                    import("../views/MedicalFiles/MedicalFile.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.medicalFiles", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.medicalFiles', 2), to: { name: 'medical-files' } },
                    //         { text: i18n.tc('message.medicalFiles', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "trajet-patients",
              redirect: "trajet-patients",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "trajet-patients",
                  component: () =>
                    import("../views/TrajetPatients/Trajet-patient.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.Trajet", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.medicalFiles', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: ":file/add",
                  name: "add-trajet-patient",
                  component: () =>
                    import("../views/TrajetPatients/AddTimeline.vue"),
                  meta: {
                    title: i18n.t("message.Addligne"),
                  },
                },
                {
                  path: "lists-timelines/:file",
                  name: "lists-timelines",
                  component: () =>
                    import("../views/TrajetPatients/TimeLinePatient.vue"),
                  meta: {
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.Timeline", 1),
                  },
                },
                {
                  path: ":ligne-temps/edit",
                  name: "edit-trajet-patient",
                  component: () =>
                    import("../views/TrajetPatients/EditTimeline.vue"),
                  meta: {
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.Timeline", 1),
                  },
                },
                {
                  path: ":file",
                  name: "trajet-patient",
                  component: () =>
                    import("../views/TrajetPatients/TrajetPatient.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.Trajet", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.medicalFiles', 2), to: { name: 'medical-files' } },
                    //         { text: i18n.tc('message.medicalFiles', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            /*{
                            path: 'exams/physical',
                            redirect: 'phyical-exams',
                            component: InheritLayout,
                            children: [
                                {
                                    path: '',
                                    name: 'physical-exams',
                                    component: () => import('../views/Exams/Physical/PhysicalExams.vue'),
                                    meta: {
                                        //requiresAuth: true,
                                        title: i18n.tc('message.physicalExams', 2)
                                    }
                                },
                                {
                                    path: 'add',
                                    name: 'add-physical-exam',
                                    component: () => import('../views/Exams/Physical/AddPhysicalExam.vue'),
                                    meta: {
                                        //requiresAuth: true,
                                        title: i18n.t('message.add') + ' ' + i18n.tc('message.physicalExams', 1)
                                    }
                                },
                                {
                                    path: ':physical/edit',
                                    name: 'edit-physical-exam',
                                    component: () => import('../views/Exams/Physical/EditPhysicalExam.vue'),
                                    meta: {
                                        //requiresAuth: true,
                                        title: i18n.t('message.edit') + ' ' + i18n.tc('message.physicalExams', 1)
                                    }
                                },
                                {
                                    path: ':physical',
                                    name: 'physical-exam',
                                    component: () => import('../views/Exams/Physical/PhysicalExam.vue'),
                                    meta: {
                                        //requiresAuth: true,
                                        title: i18n.tc('message.physicalExams', 1)
                                    }
                                }
                            ]
                        },
                        {
                            path: 'exams/complementary',
                            redirect: 'complementary-exams',
                            component: InheritLayout,
                            children: [
                                {
                                    path: '',
                                    name: 'complementary-exams',
                                    component: () => import('../views/Exams/Complementary/ComplementaryExams.vue'),
                                    meta: {
                                        //requiresAuth: true,
                                        title: i18n.tc('message.complementaryExams', 2)
                                    }
                                },
                                {
                                    path: 'add',
                                    name: 'add-complementary-exam',
                                    component: () => import('../views/Exams/Complementary/AddComplementaryExam.vue'),
                                    meta: {
                                        //requiresAuth: true,
                                        title: i18n.t('message.add') + ' ' + i18n.tc('message.complementaryExams', 1)
                                    }
                                },
                                {
                                    path: ':complementary/edit',
                                    name: 'edit-complementary-exam',
                                    component: () => import('../views/Exams/Complementary/EditComplementaryExam.vue'),
                                    meta: {
                                        //requiresAuth: true,
                                        title: i18n.t('message.edit') + ' ' + i18n.tc('message.complementaryExams', 1)
                                    }
                                },
                                {
                                    path: ':complementary',
                                    name: 'complementary-exam',
                                    component: () => import('../views/Exams/Complementary/ComplementaryExam.vue'),
                                    meta: {
                                        //requiresAuth: true,
                                        title: i18n.tc('message.complementaryExams', 1)
                                    }
                                }
                            ]
                        },*/
            {
              path: "affiliations",
              redirect: "affiliations",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "affiliations",
                  component: () =>
                    import("../views/Affiliations/Affiliations.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.affiliations", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-affiliation",
                  component: () =>
                    import("../views/Affiliations/AddAffiliation.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.affiliations", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":affiliation/edit",
                  name: "edit-affiliation",
                  component: () =>
                    import("../views/Affiliations/EditAffiliation.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.editAffiliation"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":affiliation",
                  name: "affiliation",
                  component: () =>
                    import("../views/Affiliations/Affiliation.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.affiliations", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.tc('message.affiliations', 1), active: true }
                    //     ]
                  },
                },
              ],
            },

            {
              path: "accountants",
              redirect: "accountants",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "accountants",
                  component: () =>
                    import("../views/Accountant/Accountants.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.comptable", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-accountant",
                  component: () =>
                    import("../views/Accountant/AddAccountant.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addInstitution"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":accountant/edit",
                  name: "edit-accountant",
                  component: () =>
                    import("../views/Accountant/EditAccountant.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.institutions", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":accountant",
                  name: "accountant",
                  component: () => import("../views/Accountant/Accountant.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.institutions", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.tc('message.affiliations', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "categorie-prestations",
              redirect: "categorie-prestations",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "categorie-prestations",
                  component: () =>
                    import("../views/Categorie-prestation/List.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.categoriePrestation"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-categorie-prestation",
                  component: () =>
                    import("../views/Categorie-prestation/Add.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.t("message.categoriePrestation"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":categorie/edit",
                  name: "edit-categorie-prestation",
                  component: () =>
                    import("../views/Categorie-prestation/Edit.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.t("message.categoriePrestation"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":categorie",
                  name: "categorie-prestation",
                  component: () =>
                    import("../views/Categorie-prestation/Show.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.categoriePrestation"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.tc('message.affiliations', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "prestation",
              redirect: "prestations",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "prestations",
                  component: () => import("../views/Prestation/List.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.prestation", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-prestation",
                  component: () => import("../views/Prestation/Add.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.prestation", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":prestation/edit",
                  name: "edit-prestation",
                  component: () => import("../views/Prestation/Edit.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.prestation", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":prestation",
                  name: "prestation",
                  component: () => import("../views/Prestation/Show.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.prestation", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.tc('message.affiliations', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "facturations",
              redirect: "facturations",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "facturations",
                  component: () => import("../views/Facturations.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.facturations", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "/mes-affilies",
              redirect: "medical-advice",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "mesAffilies",
                  // route level code-splitting
                  // this generates a separate chunk (about.[hash].js) for this route
                  // which is lazy-loaded when the route is visited.
                  component: () =>
                    import(
                      /* webpackChunkName: "demo" */ "../views/Subscribers/MesAffilies.vue"
                    ),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.listOfAffilaites"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.practionerDashboard'), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "/souscripteur-dashboard",
              name: "SouscripteurDashboard",
              component: InheritLayout,
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () =>
                import(
                  /* webpackChunkName: "demo" */ "../views/Dashboard/SouscripteurDashboard.vue"
                ),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.SouscripteurDashboard"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), active: true }
                //     ]
              },
            },
            {
              path: "/bienvenue",
              name: "WelcomeBack",
              component: InheritLayout,
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () =>
                import(
                  /* webpackChunkName: "demo" */ "../views/Dashboard/oldSubcriber.vue"
                ),
              meta: {
                //requiresAuth: true,
                title: i18n.t("Bienvenue sur medsurlink"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), active: true }
                //     ]
              },
            },
            {
              path: "/bienvenue-sur-medsurlink",
              name: "WelcomeMedsurlink",
              component: InheritLayout,
              // route level code-splitting
              // this generates a separate chunk (about.[hash].js) for this route
              // which is lazy-loaded when the route is visited.
              component: () =>
                import(
                  /* webpackChunkName: "demo" */ "../views/Dashboard/WelcomeMedsurlink.vue"
                ),
              meta: {
                //requiresAuth: true,
                title: i18n.t("Bienvenue sur medsurlink"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), active: true }
                //     ]
              },
            },

            {
              path: "/user-info",
              name: "UserInfo",
              component: InheritLayout,
              component: () => import("../components/UserInfo.vue"),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.infopersonnelle"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), active: true }
                //     ]
              },
            },

            {
              path: "/paiement-prestation",
              name: "PaiementPrestation",
              component: InheritLayout,
              component: () => import("../views/Paiement/Prestation.vue"),
              meta: {
                title: i18n.tc("message.payments", 2),
              },
            },
            // {
            //     path: 'gestion-patient',
            //     redirect: 'gestion-patient',
            //     component: InheritLayout,
            //     children: [
            //         {
            //             path: '',
            //             name: 'gestion-patient',
            //             component: () => import('../views/Patiens.vue'),
            //             meta: {
            //                 title: i18n.tc('message.gestionPatient',2),
            //             }
            //         },
            //     ]
            // },
            {
              path: "factures-avis",
              redirect: "factures-avis",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "factures-avis",
                  component: () => import("../views/FactureAvis/List.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.facture", 2),
                  },
                },
                {
                  path: "add",
                  name: "add-factures-avis",
                  component: () => import("../views/FactureAvis/Add.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.ajouterFacture"),
                  },
                },
                {
                  path: ":facture/edit",
                  name: "edit-factures-avis",
                  component: () => import("../views/FactureAvis/Edit.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.facture", 1),
                  },
                },
                {
                  path: ":facture",
                  name: "facture-avis",
                  component: () => import("../views/FactureAvis/Show.vue"),
                  meta: {
                    title: i18n.tc("message.facture", 1),
                  },
                },
              ],
            },
            {
              path: "factures",
              redirect: "factures",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "factures",
                  component: () => import("../views/Factures/List.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.facture", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-facture",
                  component: () => import("../views/Factures/Add.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.ajouterFacture"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":facture/edit",
                  name: "edit-facture",
                  component: () => import("../views/Factures/Edit.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.facture", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":facture",
                  name: "facture",
                  component: () => import("../views/Factures/Show.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.facture", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.tc('message.affiliations', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "etablissement-prestations",
              redirect: "etablissement-prestations",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "etablissement-prestations",
                  component: () =>
                    import("../views/Etablissement-prestation/List.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.prestation", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: ":prestation_etablissement/prestations",
                  name: "etablissement-prestations-list",
                  component: () =>
                    import(
                      "../views/Etablissement-prestation/ListPrestationOfInstitution.vue"
                    ),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.prestation", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-etablissement-prestations",
                  component: () =>
                    import("../views/Etablissement-prestation/Add.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.prestation", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: "import-prestation",
                  name: "import-prestation",
                  component: () =>
                    import("../views/Etablissement-prestation/ImportCsv.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.importPrestation"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":prestation_etablissement/edit",
                  name: "edit-etablissement-prestations",
                  component: () =>
                    import("../views/Etablissement-prestation/Edit.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.prestation", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":prestation_etablissement",
                  name: "etablissement-prestation",
                  component: () =>
                    import("../views/Etablissement-prestation/Show.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.prestation", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.tc('message.affiliations', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "etablissement-prices",
              redirect: "etablissement-prices",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "etablissement-prices",
                  component: () =>
                    import("../views/Etablissement-price/List.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.EtablissementPrix", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: ":prestation_etablissement/prices",
                  // :prestation_etablissement/prestation
                  name: "etablissement-prices-list",
                  component: () =>
                    import(
                      "../views/Etablissement-price/ListPrixOfInstitution.vue"
                    ),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.EtablissementPrix", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-etablissement-prices",
                  component: () =>
                    import("../views/Etablissement-price/Add.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.EtablissementPrix", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: "import-price",
                  name: "import-price",
                  component: () =>
                    import("../views/Etablissement-price/ImportCsv.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.importPrestation"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":price_etablissement/edit",
                  name: "edit-etablissement-prices",
                  component: () =>
                    import("../views/Etablissement-price/Edit.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.EtablissementPrix", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":price_etablissement",
                  name: "etablissement-price",
                  component: () =>
                    import("../views/Etablissement-price/Show.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.EtablissementPrix", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.affiliations', 2), to: { name: 'affiliations' } },
                    //         { text: i18n.tc('message.affiliations', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "reasons",
              redirect: "reasons",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "reasons",
                  component: () => import("../views/Reasons/Reasons.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.reasons", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.reasons', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-reason",
                  component: () => import("../views/Reasons/AddReason.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.reasons", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.reasons', 2), to: { name: 'reasons' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":reason/edit",
                  name: "edit-reason",
                  component: () => import("../views/Reasons/EditReason.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.reasons", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.reasons', 2), to: { name: 'reasons' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":reason",
                  name: "reason",
                  component: () => import("../views/Reasons/Reason.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.reasons", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.reasons', 2), to: { name: 'reasons' } },
                    //         { text: i18n.tc('message.reasons', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "professions",
              redirect: "professions",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "professions",
                  component: () =>
                    import("../views/Professions/Professions.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.professions", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.professions', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-profession",
                  component: () =>
                    import("../views/Professions/AddProfession.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.professions", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.professions', 2), to: { name: 'professions' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":profession/edit",
                  name: "edit-profession",
                  component: () =>
                    import("../views/Professions/EditProfession.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.professions", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.professions', 2), to: { name: 'professions' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":profession",
                  name: "profession",
                  component: () =>
                    import("../views/Professions/Profession.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.professions", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.professions', 2), to: { name: 'professions' } },
                    //         { text: i18n.tc('message.professions', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "specialties",
              redirect: "specialties",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "specialties",
                  component: () =>
                    import("../views/Specialties/Specialties.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.specialties", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.specialties', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-specialty",
                  component: () =>
                    import("../views/Specialties/AddSpecialty.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.specialties", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.specialties', 2), to: { name: 'specialties' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":specialty/edit",
                  name: "edit-specialty",
                  component: () =>
                    import("../views/Specialties/EditSpecialty.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.specialties", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.specialties', 2), to: { name: 'specialties' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":specialty",
                  name: "specialty",
                  component: () => import("../views/Specialties/Specialty.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.specialties", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.specialties', 2), to: { name: 'specialties' } },
                    //         { text: i18n.tc('message.specialties', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "institutions",
              redirect: "institutions",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "institutions",
                  component: () =>
                    import("../views/Institutions/Institutions.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.institutions", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.institutions', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-institution",
                  component: () =>
                    import("../views/Institutions/AddInstitution.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addInstitution"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.institutions', 2), to: { name: 'institutions' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":institution/edit",
                  name: "edit-institution",
                  component: () =>
                    import("../views/Institutions/EditInstitution.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.institutions", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.institutions', 2), to: { name: 'institutions' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":institution",
                  name: "institution",
                  component: () =>
                    import("../views/Institutions/Institution.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.institutions", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.adminManagement'), to: { name: 'admin-management' } },
                    //         { text: i18n.tc('message.institutions', 2), to: { name: 'institutions' } },
                    //         { text: i18n.tc('message.institutions', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
          ],
        },
        {
          path: "medical-management",
          redirect: "medical-management",
          component: AdminLayout,
          children: [
            {
              path: "",
              name: "medical-management",
              // component: () => import('../views/DossierMedicalManagement.vue'),
              component: () => import("../views/MedicalManagement.vue"),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.medicalManagement"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.medicalManagement'), active: true }
                //     ]
              },
            },
            {
              path: "dossier-management",
              name: "dossier-management",
              component: () => import("../views/DossierMedicalManagement.vue"),
              // component: () => import('../views/MedicalManagement.vue'),
              meta: {
                //requiresAuth: true,
                title: i18n.t("message.medicalManagement"),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.medicalManagement'), active: true }
                //     ]
              },
            },
            // {
            //     path: 'dossier-management',
            //     redirect: 'dossier-management',
            //     component: InheritLayout,
            //     children: [
            //         {
            //             path: '',
            //             name: 'dossier-management',
            //             component: () => import('../views/DossierMedicalManagement.vue'),
            //             meta: {
            //                 title: i18n.tc('message.medicalManagement',2),
            //             }
            //         },
            //     ]
            // },
            {
              path: "drugs",
              redirect: "drugs",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "drugs",
                  component: () => import("../views/Drug/Drugs.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.drug", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.hospitalisations', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "/add",
                  name: "add-drug",
                  component: () => import("../views/Drug/AddDrug.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") + " " + i18n.tc("message.drug", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":drug/edit",
                  name: "edit-drug",
                  component: () => import("../views/Drug/EditDrug.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") + " " + i18n.tc("message.drug", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":drug",
                  name: "drug",
                  component: () => import("../views/Drug/Drug.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.drug", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "prescriptions",
              redirect: "prescriptions",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "prescriptions",
                  component: () =>
                    import("../views/Prescription/Prescriptions.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.prescription"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.hospitalisations', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: ":file/add",
                  name: "add-prescription",
                  component: () =>
                    import("../views/Prescription/AddPrescription.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addPrescrip"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":prescription/edit",
                  name: "edit-prescription",
                  component: () =>
                    import("../views/Prescription/EditPrescription.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.prescriptions", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":prescription",
                  name: "prescription",
                  component: () =>
                    import("../views/Prescription/Prescription.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.prescriptions", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: "/medicament",
                  name: "medicament",
                  component: () =>
                    import("../views/Prescription/ListMedicament.vue"),
                },
              ],
            },

            {
              path: "consultations",
              redirect: "consultations",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  redirect: "consultations",
                  component: InheritLayout,
                  children: [
                    {
                      path: "",
                      name: "consultations",
                      component: () => import("../views/Consultations.vue"),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.tc("message.consultations", 2),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.tc('message.consultations', 2), active: true }
                        //     ]
                      },
                    },
                    {
                      path: "obstetriques",
                      redirect: "consultations-obstetrics",
                      component: InheritLayout,
                      children: [
                        {
                          path: "",
                          name: "consultations-obstetrics",
                          component: () =>
                            import(
                              "../views/Consultations/Obstetrics/Obstetrics.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.tc("message.obstetricConsultations", 2),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":file/add",
                          name: "add-consultation-obstetric",
                          component: () =>
                            import(
                              "../views/Consultations/Obstetrics/AddObstetric.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.add") +
                              " " +
                              i18n.tc("message.obstetricConsultations", 1),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.t('message.add'), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":consultation/edit",
                          name: "edit-consultation-obstetric",
                          component: () =>
                            import(
                              "../views/Consultations/Obstetrics/EditObstetric.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.edit") +
                              " " +
                              i18n.tc("message.obstetricConsultations", 1),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.t('message.edit'), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":consultation",
                          redirect: "consultation-obstetric",
                          component: InheritLayout,
                          children: [
                            {
                              path: "",
                              name: "consultation-obstetric",
                              component: () =>
                                import(
                                  "../views/Consultations/Obstetrics/Obstetric.vue"
                                ),
                              meta: {
                                //requiresAuth: true,
                                title: i18n.tc(
                                  "message.obstetricConsultations",
                                  1
                                ),
                                //     breadcrumbs: [
                                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                //         { text: i18n.tc('message.obstetricConsultations', 1), active: true }
                                //     ]
                              },
                            },
                            {
                              path: "echographies",
                              redirect: "ultrasounds",
                              component: InheritLayout,
                              children: [
                                {
                                  path: "",
                                  name: "ultrasounds",
                                  component: () =>
                                    import(
                                      "../views/Ultrasounds/Ultrasounds.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: i18n.tc("message.ultrasounds", 2),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                                    //         { text: i18n.tc('message.ultrasounds', 2), active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: "add",
                                  name: "add-ultrasound",
                                  component: () =>
                                    import(
                                      "../views/Ultrasounds/AddUltrasound.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title:
                                      i18n.t("message.add") +
                                      " " +
                                      i18n.tc("message.ultrasounds", 1),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                                    //         { text: i18n.tc('message.ultrasounds', 2), to: { name: 'ultrasounds' } },
                                    //         { text: i18n.t('message.add'), active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: ":ultrasound/edit",
                                  name: "edit-ultrasound",
                                  component: () =>
                                    import(
                                      "../views/Ultrasounds/EditUltrasound.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title:
                                      i18n.t("message.edit") +
                                      " " +
                                      i18n.tc("message.ultrasounds", 1),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                                    //         { text: i18n.tc('message.ultrasounds', 2), to: { name: 'ultrasounds' } },
                                    //         { text: i18n.t('message.edit'), active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: ":ultrasound",
                                  name: "ultrasound",
                                  component: () =>
                                    import(
                                      "../views/Ultrasounds/Ultrasound.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: i18n.tc("message.ultrasounds", 1),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                                    //         { text: i18n.tc('message.ultrasounds', 2), to: { name: 'ultrasounds' } },
                                    //         { text: i18n.tc('message.ultrasounds', 1), active: true }
                                    //     ]
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          path: ":consultation/consultations-prenatals-per-obstetric",
                          name: "consultations-prenatals-per-obstetric",
                          component: () =>
                            import(
                              "../views/Consultations/Prenatals/ListPrenatalPerObstetric.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.tc("message.prenatalConsultations", 2),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                            //         { text: i18n.tc('message.prenatalConsultations', 2), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":consultation/add-consultation-prenatal",
                          name: "add-consultation-prenatal",
                          component: () =>
                            import(
                              "../views/Consultations/Prenatals/AddPrenatal.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.add") +
                              " " +
                              i18n.tc("message.prenatalConsultations", 1),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                            //         { text: i18n.tc('message.prenatalConsultations', 2), to: { name: 'consultations-prenatals-per-obstetric' } },
                            //         { text: i18n.t('message.add'), active: true }
                            //     ]
                          },
                        },
                      ],
                    },
                    {
                      path: "general",
                      redirect: "consultations-generals",
                      component: InheritLayout,
                      children: [
                        {
                          path: "",
                          name: "consultations-generals",
                          component: () =>
                            import(
                              "../views/Consultations/GeneralMedicine/GeneralMedicines.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.tc("message.generalConsultations", 2),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.generalConsultations', 2), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":file/add",
                          name: "add-consultation-general",
                          component: () =>
                            import(
                              "../views/Consultations/GeneralMedicine/NewGeneralMedecine.vue"
                            ),
                          //component: () => import('../views/Consultations/GeneralMedicine/AddGeneralMedicine.vue'),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.t("message.addConsul"),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                            //         { text: i18n.t('message.add'), active: true }
                            //     ]
                          },
                        },

                        {
                          path: ":consultation/edit",
                          name: "edit-consultation-general",
                          //component: () => import('../views/Consultations/GeneralMedicine/EditGeneralMedicine.vue'),
                          component: () =>
                            import(
                              "../views/Consultations/GeneralMedicine/NewEditGeneralMedicine.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.t("message.editGeneratlConsul"),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                            //         { text: i18n.t('message.edit'), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":consultation",
                          redirect: "consultation-general",
                          component: InheritLayout,
                          children: [
                            {
                              path: "",
                              name: "consultation-general",
                              // component: () => import('../views/Consultations/GeneralMedicine/OldConsultationGeneralMedicine.vue'),
                              component: () =>
                                import(
                                  "../views/Consultations/GeneralMedicine/GeneralMedicine.vue"
                                ),
                              meta: {
                                //requiresAuth: true,
                                title: i18n.tc(
                                  "message.generalConsultations",
                                  1
                                ),
                                //     breadcrumbs: [
                                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                //         { text: i18n.tc('message.generalConsultations', 1), active: true }
                                //     ]
                              },
                            },
                            {
                              path: "reasons",
                              redirect: "consultation-reasons",
                              component: InheritLayout,
                              children: [
                                {
                                  path: "",
                                  name: "consultation-reasons",
                                  component: () =>
                                    import(
                                      "../views/Consultations/GeneralMedicine/Reasons/Reasons.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: i18n.tc("message.reasons", 2),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                    //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                    //         { text: i18n.tc('message.reasons', 2), active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: "add",
                                  name: "add-consultation-reason",
                                  component: () =>
                                    import(
                                      "../views/Consultations/GeneralMedicine/Reasons/AddReason.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: `${i18n.t("message.add")} ${i18n.tc(
                                      "message.reasons",
                                      1
                                    )}`,
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                    //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                    //         //{ text: i18n.tc('message.reasons', 2), to: { name: 'consultation-reasons' } },
                                    //         { text: `${i18n.t('message.add')} ${i18n.tc('message.reasons', 1)}`, active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: ":reason/edit",
                                  name: "edit-consultation-reason",
                                  component: () =>
                                    import(
                                      "../views/Consultations/GeneralMedicine/Reasons/EditReason.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: `${i18n.t("message.edit")} ${i18n.tc(
                                      "message.reasons",
                                      1
                                    )}`,
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                    //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                    //         { text: i18n.tc('message.reasons', 2), to: { name: 'consultation-reasons' } },
                                    //         { text: i18n.t('message.edit'), active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: ":reason",
                                  name: "consultation-reason",
                                  component: () =>
                                    import(
                                      "../views/Consultations/GeneralMedicine/Reasons/Reason.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: i18n.tc("message.reasons", 1),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                    //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                    //         { text: i18n.tc('message.reasons', 2), to: { name: 'consultation-reasons' } },
                                    //         { text: i18n.tc('message.reasons', 1), active: true }
                                    //     ]
                                  },
                                },
                              ],
                            },
                            {
                              path: "exams",
                              redirect: "consultation-physical-exams",
                              component: InheritLayout,
                              children: [
                                {
                                  path: "physical",
                                  redirect: "consultation-physical-exams",
                                  component: InheritLayout,
                                  children: [
                                    {
                                      path: "",
                                      name: "consultation-physical-exams",
                                      component: () =>
                                        import(
                                          "../views/Consultations/GeneralMedicine/Exams/Physical/PhysicalExams.vue"
                                        ),
                                      meta: {
                                        //requiresAuth: true,
                                        title: i18n.tc(
                                          "message.physicalExams",
                                          2
                                        ),
                                        //     breadcrumbs: [
                                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                        //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                        //         { text: i18n.tc('message.physicalExams', 2), active: true }
                                        //     ]
                                      },
                                    },
                                    {
                                      path: "add",
                                      name: "add-consultation-physical-exam",
                                      component: () =>
                                        import(
                                          "../views/Consultations/GeneralMedicine/Exams/Physical/AddPhysicalExam.vue"
                                        ),
                                      meta: {
                                        //requiresAuth: true,
                                        title:
                                          i18n.t("message.add") +
                                          " " +
                                          i18n.tc("message.physicalExams", 1),
                                        //     breadcrumbs: [
                                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                        //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                        //         { text: i18n.tc('message.physicalExams', 2), to: { name: 'consultation-physical-exams' } },
                                        //         { text: i18n.t('message.add'), active: true }
                                        //     ]
                                      },
                                    },
                                    {
                                      path: ":physical",
                                      name: "consultation-physical-exam",
                                      component: () =>
                                        import(
                                          "../views/Consultations/GeneralMedicine/Exams/Physical/PhysicalExam.vue"
                                        ),
                                      meta: {
                                        //requiresAuth: true,
                                        title: i18n.tc(
                                          "message.physicalExams",
                                          1
                                        ),
                                        //     breadcrumbs: [
                                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                        //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                        //         { text: i18n.tc('message.physicalExams', 2), to: { name: 'consultation-physical-exams' } },
                                        //         { text: i18n.tc('message.physicalExams', 1), active: true }
                                        //     ]
                                      },
                                    },
                                  ],
                                },
                                {
                                  path: "complementary",
                                  redirect: "consultation-complementary-exams",
                                  component: InheritLayout,
                                  children: [
                                    {
                                      path: "",
                                      name: "consultation-complementary-exams",
                                      component: () =>
                                        import(
                                          "../views/Consultations/GeneralMedicine/Exams/Complementary/ComplementaryExams.vue"
                                        ),
                                      meta: {
                                        //requiresAuth: true,
                                        title: i18n.tc(
                                          "message.complementaryExams",
                                          2
                                        ),
                                        //     breadcrumbs: [
                                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                        //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                        //         { text: i18n.tc('message.complementaryExams', 2), active: true }
                                        //     ]
                                      },
                                    },
                                    {
                                      path: "add",
                                      name: "add-consultation-complementary-exam",
                                      component: () =>
                                        import(
                                          "../views/Consultations/GeneralMedicine/Exams/Complementary/AddComplementaryExam.vue"
                                        ),
                                      meta: {
                                        //requiresAuth: true,
                                        title:
                                          i18n.t("message.add") +
                                          " " +
                                          i18n.tc(
                                            "message.complementaryExams",
                                            1
                                          ),
                                        //     breadcrumbs: [
                                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                        //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                        //         { text: i18n.tc('message.complementaryExams', 2), to: { name: 'consultation-complementary-exams' } },
                                        //         { text: i18n.t('message.add'), active: true }
                                        //     ]
                                      },
                                    },
                                    {
                                      path: ":complementary",
                                      name: "consultation-complementary-exam",
                                      component: () =>
                                        import(
                                          "../views/Consultations/GeneralMedicine/Exams/Complementary/ComplementaryExam.vue"
                                        ),
                                      meta: {
                                        //requiresAuth: true,
                                        title: i18n.tc(
                                          "message.complementaryExams",
                                          1
                                        ),
                                        //     breadcrumbs: [
                                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                        //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                        //         { text: i18n.tc('message.complementaryExams', 2), to: { name: 'consultation-complementary-exams' } },
                                        //         { text: i18n.tc('message.complementaryExams', 1), active: true }
                                        //     ]
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      path: "tele",
                      redirect: "consultations-tele",
                      component: InheritLayout,
                      children: [
                        {
                          path: "",
                          name: "consultations-tele",
                          component: () =>
                            import(
                              "../views/Consultations/TeleMedicine/TeleMedicines.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.tc("message.teleConsultations", 2),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.generalConsultations', 2), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":file/add",
                          name: "add-tele-consultation",
                          component: () =>
                            import(
                              "../views/Consultations/TeleMedicine/NewTeleMedecine.vue"
                            ),
                          //component: () => import('../views/Consultations/GeneralMedicine/AddGeneralMedicine.vue'),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.add") +
                              " " +
                              i18n.tc("message.teleConsultations", 1),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                            //         { text: i18n.t('message.add'), active: true }
                            //     ]
                          },
                        },

                        {
                          path: ":consultation/edit",
                          name: "edit-tele-consultation",
                          //component: () => import('../views/Consultations/GeneralMedicine/EditGeneralMedicine.vue'),
                          component: () =>
                            import(
                              "../views/Consultations/TeleMedicine/NewEditTeleMedicine.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.edit") +
                              " " +
                              i18n.tc("message.teleConsultations", 1),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                            //         { text: i18n.t('message.edit'), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":consultation",
                          redirect: "tele-consultation",
                          component: InheritLayout,
                          children: [
                            {
                              path: "",
                              name: "tele-consultation",
                              // component: () => import('../views/Consultations/GeneralMedicine/OldConsultationGeneralMedicine.vue'),
                              component: () =>
                                import(
                                  "../views/Consultations/TeleMedicine/TeleMedicine.vue"
                                ),
                              meta: {
                                //requiresAuth: true,
                                title: i18n.tc("message.teleConsultations", 1),
                                //     breadcrumbs: [
                                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                //         { text: i18n.tc('message.generalConsultations', 1), active: true }
                                //     ]
                              },
                            },
                            {
                              path: "reasons",
                              redirect: "consultation-reasons",
                              component: InheritLayout,
                              children: [
                                {
                                  path: "",
                                  name: "consultation-reasons",
                                  component: () =>
                                    import(
                                      "../views/Consultations/TeleMedicine/Reasons/Reasons.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: i18n.tc("message.reasons", 2),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                    //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                    //         { text: i18n.tc('message.reasons', 2), active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: "add",
                                  name: "add-consultation-reason",
                                  component: () =>
                                    import(
                                      "../views/Consultations/TeleMedicine/Reasons/AddReason.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: `${i18n.t("message.add")} ${i18n.tc(
                                      "message.reasons",
                                      1
                                    )}`,
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                    //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                    //         //{ text: i18n.tc('message.reasons', 2), to: { name: 'consultation-reasons' } },
                                    //         { text: `${i18n.t('message.add')} ${i18n.tc('message.reasons', 1)}`, active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: ":reason/edit",
                                  name: "edit-consultation-reason",
                                  component: () =>
                                    import(
                                      "../views/Consultations/TeleMedicine/Reasons/EditReason.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: `${i18n.t("message.edit")} ${i18n.tc(
                                      "message.reasons",
                                      1
                                    )}`,
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                    //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                    //         { text: i18n.tc('message.reasons', 2), to: { name: 'consultation-reasons' } },
                                    //         { text: i18n.t('message.edit'), active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: ":reason",
                                  name: "consultation-reason",
                                  component: () =>
                                    import(
                                      "../views/Consultations/TeleMedicine/Reasons/Reason.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: i18n.tc("message.reasons", 1),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                    //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                    //         { text: i18n.tc('message.reasons', 2), to: { name: 'consultation-reasons' } },
                                    //         { text: i18n.tc('message.reasons', 1), active: true }
                                    //     ]
                                  },
                                },
                              ],
                            },
                            {
                              path: "exams",
                              redirect: "consultation-physical-exams",
                              component: InheritLayout,
                              children: [
                                {
                                  path: "physical",
                                  redirect: "consultation-physical-exams",
                                  component: InheritLayout,
                                  children: [
                                    {
                                      path: "",
                                      name: "consultation-physical-exams",
                                      component: () =>
                                        import(
                                          "../views/Consultations/TeleMedicine/Exams/Physical/PhysicalExams.vue"
                                        ),
                                      meta: {
                                        //requiresAuth: true,
                                        title: i18n.tc(
                                          "message.physicalExams",
                                          2
                                        ),
                                        //     breadcrumbs: [
                                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                        //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                        //         { text: i18n.tc('message.physicalExams', 2), active: true }
                                        //     ]
                                      },
                                    },
                                    {
                                      path: "add",
                                      name: "add-consultation-physical-exam",
                                      component: () =>
                                        import(
                                          "../views/Consultations/TeleMedicine/Exams/Physical/AddPhysicalExam.vue"
                                        ),
                                      meta: {
                                        //requiresAuth: true,
                                        title:
                                          i18n.t("message.add") +
                                          " " +
                                          i18n.tc("message.physicalExams", 1),
                                        //     breadcrumbs: [
                                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                        //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                        //         { text: i18n.tc('message.physicalExams', 2), to: { name: 'consultation-physical-exams' } },
                                        //         { text: i18n.t('message.add'), active: true }
                                        //     ]
                                      },
                                    },
                                    {
                                      path: ":physical",
                                      name: "consultation-physical-exam",
                                      component: () =>
                                        import(
                                          "../views/Consultations/TeleMedicine/Exams/Physical/PhysicalExam.vue"
                                        ),
                                      meta: {
                                        //requiresAuth: true,
                                        title: i18n.tc(
                                          "message.physicalExams",
                                          1
                                        ),
                                        //     breadcrumbs: [
                                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                        //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                        //         { text: i18n.tc('message.physicalExams', 2), to: { name: 'consultation-physical-exams' } },
                                        //         { text: i18n.tc('message.physicalExams', 1), active: true }
                                        //     ]
                                      },
                                    },
                                  ],
                                },
                                {
                                  path: "complementary",
                                  redirect: "consultation-complementary-exams",
                                  component: InheritLayout,
                                  children: [
                                    {
                                      path: "",
                                      name: "consultation-complementary-exams",
                                      component: () =>
                                        import(
                                          "../views/Consultations/TeleMedicine/Exams/Complementary/ComplementaryExams.vue"
                                        ),
                                      meta: {
                                        //requiresAuth: true,
                                        title: i18n.tc(
                                          "message.complementaryExams",
                                          2
                                        ),
                                        //     breadcrumbs: [
                                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                        //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                        //         { text: i18n.tc('message.complementaryExams', 2), active: true }
                                        //     ]
                                      },
                                    },
                                    {
                                      path: "add",
                                      name: "add-consultation-complementary-exam",
                                      component: () =>
                                        import(
                                          "../views/Consultations/TeleMedicine/Exams/Complementary/AddComplementaryExam.vue"
                                        ),
                                      meta: {
                                        //requiresAuth: true,
                                        title:
                                          i18n.t("message.add") +
                                          " " +
                                          i18n.tc(
                                            "message.complementaryExams",
                                            1
                                          ),
                                        //     breadcrumbs: [
                                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                        //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                        //         { text: i18n.tc('message.complementaryExams', 2), to: { name: 'consultation-complementary-exams' } },
                                        //         { text: i18n.t('message.add'), active: true }
                                        //     ]
                                      },
                                    },
                                    {
                                      path: ":complementary",
                                      name: "consultation-complementary-exam",
                                      component: () =>
                                        import(
                                          "../views/Consultations/TeleMedicine/Exams/Complementary/ComplementaryExam.vue"
                                        ),
                                      meta: {
                                        //requiresAuth: true,
                                        title: i18n.tc(
                                          "message.complementaryExams",
                                          1
                                        ),
                                        //     breadcrumbs: [
                                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                        //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                                        //         { text: i18n.tc('message.complementaryExams', 2), to: { name: 'consultation-complementary-exams' } },
                                        //         { text: i18n.tc('message.complementaryExams', 1), active: true }
                                        //     ]
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      path: "prenatales",
                      redirect: "consultations-prenatals",
                      component: InheritLayout,
                      children: [
                        {
                          path: "",
                          name: "consultations-prenatals",
                          component: () =>
                            import(
                              "../views/Consultations/Prenatals/Prenatals.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.tc("message.prenatalConsultations", 2),
                          },
                        },
                        {
                          path: ":consultation/edit",
                          name: "edit-consultation-prenatal",
                          component: () =>
                            import(
                              "../views/Consultations/Prenatals/EditPrenatal.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.edit") +
                              " " +
                              i18n.tc("message.prenatalConsultations", 1),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                            //         { text: i18n.tc('message.prenatalConsultations', 2), to: { name: 'consultations-prenatals-per-obstetric' } },
                            //         { text: i18n.t('message.edit'), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":consultation",
                          name: "consultation-prenatal",
                          component: () =>
                            import(
                              "../views/Consultations/Prenatals/Prenatal.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.tc("message.prenatalConsultations", 1),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                            //         { text: i18n.tc('message.prenatalConsultations', 2), to: { name: 'consultations-prenatals-per-obstetric' } },
                            //         { text: i18n.tc('message.prenatalConsultations', 1), active: true },
                            //     ]
                          },
                        },
                        /*{
                                                    path: ':consultation/echographies',
                                                    name: 'ultrasounds',
                                                    component: () => import('../views/Ultrasounds/Ultrasounds.vue'),
                                                    meta: {
                                                        //requiresAuth: true,
                                                        title: i18n.tc('message.ultrasounds', 2)
                                                    }
                                                },
                                                {
                                                    path: ':consultation/echographies/add',
                                                    name: 'add-ultrasound',
                                                    component: () => import('../views/Ultrasounds/AddUltrasound.vue'),
                                                    meta: {
                                                        //requiresAuth: true,
                                                        title: i18n.t('message.add') + ' ' + i18n.tc('message.ultrasounds', 1)
                                                    }
                                                },
                                                {
                                                    path: ':consultation/echographies/:ultrasound/edit',
                                                    name: 'edit-ultrasound',
                                                    component: () => import('../views/Ultrasounds/EditUltrasound.vue'),
                                                    meta: {
                                                        //requiresAuth: true,
                                                        title: i18n.t('message.edit') + ' ' + i18n.tc('message.ultrasounds', 1)
                                                    }
                                                },
                                                {
                                                    path: ':consultation/echographies/:ultrasound',
                                                    name: 'ultrasound',
                                                    component: () => import('../views/Ultrasounds/Ultrasound.vue'),
                                                    meta: {
                                                        //requiresAuth: true,
                                                        title: i18n.tc('message.ultrasounds', 1)
                                                    }
                                                },*/
                        {
                          path: ":consultation/parametres-obstetrique",
                          name: "parameters-obstetric",
                          component: () =>
                            import(
                              "../views/Parameters/Obstetrics/Obstetrics.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.tc("message.obstetricParameters", 2),
                          },
                        },
                        {
                          path: ":consultation/parametre-obstetrique/add",
                          name: "add-parameter-obstetric",
                          component: () =>
                            import(
                              "../views/Parameters/Obstetrics/AddObstetric.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.add") +
                              " " +
                              i18n.tc("message.obstetricParameters", 1),
                          },
                        },
                        {
                          path: ":consultation/parametre-obstetrique/:parametreObstetrique/edit",
                          name: "edit-parameter-obstetric",
                          component: () =>
                            import(
                              "../views/Parameters/Obstetrics/EditObstetric.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.edit") +
                              " " +
                              i18n.tc("message.obstetricParameters", 1),
                          },
                        },
                        {
                          path: ":consultation/parametre-obstetrique/:parametreObstetrique",
                          name: "parameter-obstetric",
                          component: () =>
                            import(
                              "../views/Parameters/Obstetrics/Obstetric.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.tc("message.obstetricParameters", 1),
                          },
                        },
                        {
                          path: ":consultation/physical-examination/add",
                          name: "add-physical-examination",
                          component: () =>
                            import(
                              "../views/Exams/Physical/AddPhysicalExamsToPrenatalConsultation.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.add") +
                              " " +
                              i18n.tc("message.physicalExams", 1),
                          },
                        },
                        {
                          path: ":consultation/physical-examination/",
                          name: "prenatal-consultation-physicals-examinations",
                          component: () =>
                            import(
                              "../views/Exams/Physical/PhysicalExamsPerPrenatalConsultation.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.add") +
                              " " +
                              i18n.tc("message.physicalExams", 1),
                          },
                        },
                        {
                          path: ":consultation/complementary-examination/add",
                          name: "add-complementary-examination",
                          component: () =>
                            import(
                              "../views/Exams/Complementary/AddComplementaryExamToPrenatalConsultation.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.add") +
                              " " +
                              i18n.tc("message.complementaryExams", 1),
                          },
                        },
                        {
                          path: ":consultation/complementary-examination/",
                          name: "prenatal-consultation-complementaries-examinations",
                          component: () =>
                            import(
                              "../views/Exams/Complementary/ComplementaryExamsPerPrenatalConsultation.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.add") +
                              " " +
                              i18n.tc("message.complementaryExams", 1),
                          },
                        },
                      ],
                    },
                    {
                      path: "cardiologies",
                      redirect: "consultations-cardiologies",
                      component: InheritLayout,
                      children: [
                        {
                          path: "",
                          name: "consultations-cardiologies",
                          component: () =>
                            import(
                              "../views/Consultations/Cardiologies/Cardiologies.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.t("message.cardiologyConsultations"),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":file/add",
                          name: "add-consultation-cardiology",
                          component: () =>
                            import(
                              "../views/Consultations/Cardiologies/AddCardiology.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.add") +
                              " " +
                              i18n.t("message.cardiologyConsultations"),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.t('message.add'), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":consultation/edit",
                          name: "edit-consultation-cardiology",
                          component: () =>
                            import(
                              "../views/Consultations/Cardiologies/EditCardiology.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.edit") +
                              " " +
                              i18n.t("message.cardiologyConsultations"),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.t('message.edit'), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":consultation",
                          redirect: "consultation-cardiology",
                          component: InheritLayout,
                          children: [
                            {
                              path: "",
                              name: "consultation-cardiology",
                              component: () =>
                                import(
                                  "../views/Consultations/Cardiologies/Cardiology.vue"
                                ),
                              meta: {
                                //requiresAuth: true,
                                title: i18n.t(
                                  "message.cardiologyConsultations"
                                ),
                                //     breadcrumbs: [
                                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                //         { text: i18n.tc('message.obstetricConsultations', 1), active: true }
                                //     ]
                              },
                            },
                            {
                              path: "echographies",
                              redirect: "ultrasounds",
                              component: InheritLayout,
                              children: [
                                {
                                  path: "",
                                  name: "ultrasounds",
                                  component: () =>
                                    import(
                                      "../views/Ultrasounds/Ultrasounds.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: i18n.tc("message.ultrasounds", 2),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                                    //         { text: i18n.tc('message.ultrasounds', 2), active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: "add",
                                  name: "add-ultrasound",
                                  component: () =>
                                    import(
                                      "../views/Ultrasounds/AddUltrasound.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title:
                                      i18n.t("message.add") +
                                      " " +
                                      i18n.tc("message.ultrasounds", 1),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                                    //         { text: i18n.tc('message.ultrasounds', 2), to: { name: 'ultrasounds' } },
                                    //         { text: i18n.t('message.add'), active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: ":ultrasound/edit",
                                  name: "edit-ultrasound",
                                  component: () =>
                                    import(
                                      "../views/Ultrasounds/EditUltrasound.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title:
                                      i18n.t("message.edit") +
                                      " " +
                                      i18n.tc("message.ultrasounds", 1),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                                    //         { text: i18n.tc('message.ultrasounds', 2), to: { name: 'ultrasounds' } },
                                    //         { text: i18n.t('message.edit'), active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: ":ultrasound",
                                  name: "ultrasound",
                                  component: () =>
                                    import(
                                      "../views/Ultrasounds/Ultrasound.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: i18n.tc("message.ultrasounds", 1),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                                    //         { text: i18n.tc('message.ultrasounds', 2), to: { name: 'ultrasounds' } },
                                    //         { text: i18n.tc('message.ultrasounds', 1), active: true }
                                    //     ]
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        {
                          path: ":consultation/consultations-prenatals-per-obstetric",
                          name: "consultations-prenatals-per-obstetric",
                          component: () =>
                            import(
                              "../views/Consultations/Prenatals/ListPrenatalPerObstetric.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.tc("message.prenatalConsultations", 2),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                            //         { text: i18n.tc('message.prenatalConsultations', 2), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":consultation/add-consultation-prenatal",
                          name: "add-consultation-prenatal",
                          component: () =>
                            import(
                              "../views/Consultations/Prenatals/AddPrenatal.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.add") +
                              " " +
                              i18n.tc("message.prenatalConsultations", 1),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                            //         { text: i18n.tc('message.prenatalConsultations', 2), to: { name: 'consultations-prenatals-per-obstetric' } },
                            //         { text: i18n.t('message.add'), active: true }
                            //     ]
                          },
                        },
                      ],
                    },
                    {
                      path: "kinesitherapie",
                      redirect: "consultations-kinesitherapie",
                      component: InheritLayout,
                      children: [
                        {
                          path: "",
                          name: "consultations-kinesitherapie",
                          component: () =>
                            import(
                              "../views/Consultations/Kinesitherapies/Kinesitherapies.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.t("message.kinesitherapyConsultations"),
                          },
                        },
                        {
                          path: ":file/add",
                          name: "add-consultation-kinesitherapie",
                          component: () =>
                            import(
                              "../views/Consultations/Kinesitherapies/AddKinesitherapie.vue"
                            ),
                          meta: {
                            title:
                              i18n.t("message.add") +
                              " " +
                              i18n.t("message.kinesitherapyConsultations"),
                          },
                        },
                        {
                          path: ":kinesitherapie/edit",
                          name: "edit-consultation-kinesitherapy",
                          component: () =>
                            import(
                              "../views/Consultations/Kinesitherapies/EditKinesitherapie.vue"
                            ),
                          meta: {
                            title:
                              i18n.t("message.edit") +
                              " " +
                              i18n.t("message.kinesitherapyConsultations"),
                          },
                        },
                        {
                          path: ":kinesitherapie",
                          redirect: "consultation-kinesitherapie",
                          component: InheritLayout,
                          children: [
                            {
                              path: "",
                              name: "consultation-kinesitherapie",
                              component: () =>
                                import(
                                  "../views/Consultations/Kinesitherapies/Kinesitherapy.vue"
                                ),
                              meta: {
                                //requiresAuth: true,
                                title: i18n.t(
                                  "message.kinesitherapyConsultations"
                                ),
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      path: "manuscrits",
                      redirect: "consultations-manuscrits",
                      component: InheritLayout,
                      children: [
                        {
                          path: "",
                          name: "consultations-manuscrits",
                          component: () =>
                            import(
                              "../views/Consultations/Manuscrit/Manuscrits.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.t("message.manuscritConsultations"),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":file/add",
                          name: "add-consultation-manuscrit",
                          component: () =>
                            import(
                              "../views/Consultations/Manuscrit/AddManuscrit.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.t("message.addManuscritConsul"),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.t('message.add'), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":consultation/edit",
                          name: "edit-consultation-manuscrit",
                          component: () =>
                            import(
                              "../views/Consultations/Manuscrit/EditManuscrit.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.edit") +
                              " " +
                              i18n.t("message.manuscritConsultations"),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.t('message.edit'), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":consultation",
                          redirect: "consultation-manuscrit",
                          component: InheritLayout,
                          children: [
                            {
                              path: "",
                              name: "consultation-manuscrit",
                              component: () =>
                                import(
                                  "../views/Consultations/Manuscrit/Manuscrit.vue"
                                ),
                              meta: {
                                //requiresAuth: true,
                                title: i18n.t("message.manuscritConsultations"),
                                //     breadcrumbs: [
                                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                //         { text: i18n.tc('message.obstetricConsultations', 1), active: true }
                                //     ]
                              },
                            },
                            {
                              path: "echographies",
                              redirect: "ultrasounds",
                              component: InheritLayout,
                              children: [
                                {
                                  path: "",
                                  name: "ultrasounds",
                                  component: () =>
                                    import(
                                      "../views/Ultrasounds/Ultrasounds.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: i18n.tc("message.ultrasounds", 2),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                                    //         { text: i18n.tc('message.ultrasounds', 2), active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: "add",
                                  name: "add-ultrasound",
                                  component: () =>
                                    import(
                                      "../views/Ultrasounds/AddUltrasound.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title:
                                      i18n.t("message.add") +
                                      " " +
                                      i18n.tc("message.ultrasounds", 1),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                                    //         { text: i18n.tc('message.ultrasounds', 2), to: { name: 'ultrasounds' } },
                                    //         { text: i18n.t('message.add'), active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: ":ultrasound/edit",
                                  name: "edit-ultrasound",
                                  component: () =>
                                    import(
                                      "../views/Ultrasounds/EditUltrasound.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title:
                                      i18n.t("message.edit") +
                                      " " +
                                      i18n.tc("message.ultrasounds", 1),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                                    //         { text: i18n.tc('message.ultrasounds', 2), to: { name: 'ultrasounds' } },
                                    //         { text: i18n.t('message.edit'), active: true }
                                    //     ]
                                  },
                                },
                                {
                                  path: ":ultrasound",
                                  name: "ultrasound",
                                  component: () =>
                                    import(
                                      "../views/Ultrasounds/Ultrasound.vue"
                                    ),
                                  meta: {
                                    //requiresAuth: true,
                                    title: i18n.tc("message.ultrasounds", 1),
                                    //     breadcrumbs: [
                                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                                    //         { text: i18n.tc('message.obstetricConsultations', 1), to: { name: 'consultation-obstetric'} },
                                    //         { text: i18n.tc('message.ultrasounds', 2), to: { name: 'ultrasounds' } },
                                    //         { text: i18n.tc('message.ultrasounds', 1), active: true }
                                    //     ]
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      path: "comptes-rendu",
                      redirect: "comptes-rendu",
                      component: InheritLayout,
                      children: [
                        {
                          path: "",
                          name: "comptes-rendu",
                          component: () => import("../views/CompteRendu/List"),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.t("message.compteRenduOperatoire"),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":file/add",
                          name: "add-compte-rendu",
                          component: () => import("../views/CompteRendu/Add"),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.t("message.addCompteRenduOp"),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.t('message.add'), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":compteRendu/edit",
                          name: "edit-compte-rendu",
                          component: () => import("../views/CompteRendu/Edit"),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.t("message.edit") +
                              " " +
                              i18n.t("message.compteRenduOperatoire"),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.t('message.edit'), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":compteRendu",
                          name: "compte-rendu",
                          component: () => import("../views/CompteRendu/Show"),
                          meta: {
                            //requiresAuth: true,
                            title: i18n.t("message.compteRenduOperatoire"),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                            //         { text: i18n.tc('message.obstetricConsultations', 2), to: { name: 'consultations-obstetrics' } },
                            //         { text: i18n.t('message.edit'), active: true }
                            //     ]
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: "exams/cardiology",
              redirect: "cardiology-exams",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "cardiology-exams",
                  component: () =>
                    import("../views/Exams/Cardiology/Cardiologies.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.cardiacExam"),
                  },
                },
                {
                  path: ":cardiology/add",
                  name: "add-cardiology-exam",
                  component: () =>
                    import("../views/Exams/Cardiology/AddCardiology.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.t("message.cardiacExam"),
                  },
                },
                {
                  path: ":cardiology/edit",
                  name: "edit-cardiology-exam",
                  component: () =>
                    import("../views/Exams/Cardiology/EditCardiology.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.t("message.cardiacExam"),
                  },
                },
                {
                  path: ":cardiology",
                  name: "cardiology-exam",
                  component: () =>
                    import("../views/Exams/Cardiology/Cardiology.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.cardiacExam"),
                  },
                },
              ],
            },
            {
              path: "treatments",
              redirect: "treatments",
              component: InheritLayout,
              children: [
                {
                  path: "current",
                  redirect: "current",
                  component: InheritLayout,
                  children: [
                    {
                      path: "",
                      name: "current",
                      component: () =>
                        import("../views/Treatments/Current/Treatments.vue"),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.t("message.currentTreatments"),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.t('message.currentTreatments'), active: true }
                        //     ]
                      },
                    },
                    {
                      path: ":file/add-treatments",
                      name: "add-treatments",
                      component: () =>
                        import("../views/Treatments/Current/AddTreatment.vue"),
                      meta: {
                        //requiresAuth: true,
                        title:
                          i18n.t("message.add") +
                          " " +
                          i18n.t("message.currentTreatments"),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general' } },
                        //         { text: `${i18n.t('message.add')} ${i18n.t('message.currentTreatments')}`, active: true }
                        //     ]
                      },
                    },
                    {
                      path: ":treatment/edit",
                      name: "edit-current-treatment",
                      component: () =>
                        import("../views/Treatments/Current/EditTreatment.vue"),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.t("message.addCurrentTreatment"),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.t('message.consultations'), to: { name: 'consultations' } },
                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                        //         { text: `${i18n.tc('message.edit')} ${i18n.t('message.currentTreatments')}`, active: true }
                        //     ]
                      },
                    },
                    {
                      path: ":treatment",
                      name: "treatment",
                      component: () =>
                        import("../views/Treatments/Current/Treatment.vue"),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.t("message.currentTreatments"),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.t('message.consultations'), to: { name: 'current' } },
                        //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                        //         { text: i18n.tc('message.generalConsultations', 1), to: { name: 'consultation-general'} },
                        //         { text: i18n.t('message.currentTreatments'), active: true }
                        //     ]
                      },
                    },
                  ],
                },
              ],
            },

            {
              path: "hospitalisations",
              redirect: "hospitalisations",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "hospitalisations",
                  component: () =>
                    import("../views/Hospitalisations/Hospitalisations.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.hospitalisations", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.hospitalisations', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: ":file/add",
                  name: "add-hospitalisation",
                  component: () =>
                    import("../views/Hospitalisations/AddHospitalisation.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addHospitalisation"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":hospitalisation/edit",
                  name: "edit-hospitalisation",
                  component: () =>
                    import("../views/Hospitalisations/EditHospitalisation.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.hospitalisations", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":hospitalisation",
                  redirect: "hospitalisation",
                  component: InheritLayout,
                  children: [
                    {
                      path: "",
                      name: "hospitalisation",
                      component: () =>
                        import("../views/Hospitalisations/Hospitalisation.vue"),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.tc("message.hospitalisations", 1),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                        //         { text: i18n.tc('message.hospitalisations', 1), active: true }
                        //     ]
                      },
                    },
                    {
                      path: "physical-exams",
                      redirect: "hospitalisation.physical-exams",
                      component: InheritLayout,
                      children: [
                        {
                          path: "",
                          name: "hospitalisation.physical-exams",
                          component: () =>
                            import(
                              "../views/Hospitalisations/Exams/Physical/PhysicalExams.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.tc("message.hospitalisations", 1) +
                              " - " +
                              i18n.tc("message.physicalExams", 2),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                            //         { text: i18n.tc('message.hospitalisations', 1), to: { name: 'hospitalisation'} },
                            //         { text: i18n.tc('message.physicalExams', 2), active: true }
                            //     ]
                          },
                        },
                        {
                          path: "add",
                          name: "hospitalisation.add-physical-exam",
                          component: () =>
                            import(
                              "../views/Hospitalisations/Exams/Physical/AddPhysicalExam.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.tc("message.hospitalisations", 1) +
                              " - " +
                              i18n.t("message.add") +
                              " " +
                              i18n.tc("message.physicalExams", 1),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                            //         { text: i18n.tc('message.hospitalisations', 1), to: { name: 'hospitalisation'} },
                            //         { text: i18n.tc('message.physicalExams', 2), to: { name: 'hospitalisation.physical-exams' } },
                            //         { text: i18n.t('message.add'), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":physical",
                          name: "hospitalisation.physical-exam",
                          component: () =>
                            import(
                              "../views/Hospitalisations/Exams/Physical/PhysicalExam.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.tc("message.hospitalisations", 1) +
                              " - " +
                              i18n.tc("message.physicalExams", 1),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                            //         { text: i18n.tc('message.hospitalisations', 1), to: { name: 'hospitalisation'} },
                            //         { text: i18n.tc('message.physicalExams', 2), to: { name: 'hospitalisation.physical-exams' } },
                            //         { text: i18n.tc('message.physicalExams', 1), active: true }
                            //     ]
                          },
                        },
                      ],
                    },
                    {
                      path: "complementary-exams",
                      redirect: "hospitalisation.complementary-exams",
                      component: InheritLayout,
                      children: [
                        {
                          path: "",
                          name: "hospitalisation.complementary-exams",
                          component: () =>
                            import(
                              "../views/Hospitalisations/Exams/Complementary/ComplementaryExams.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.tc("message.hospitalisations", 1) +
                              " - " +
                              i18n.tc("message.complementaryExams", 2),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                            //         { text: i18n.tc('message.hospitalisations', 1), to: { name: 'hospitalisation'} },
                            //         { text: i18n.tc('message.complementaryExams', 2), active: true }
                            //     ]
                          },
                        },
                        {
                          path: "add",
                          name: "hospitalisation.add-complementary-exam",
                          component: () =>
                            import(
                              "../views/Hospitalisations/Exams/Complementary/AddComplementaryExam.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.tc("message.hospitalisations", 1) +
                              " - " +
                              i18n.t("message.add") +
                              " " +
                              i18n.tc("message.complementaryExams", 1),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                            //         { text: i18n.tc('message.hospitalisations', 1), to: { name: 'hospitalisation'} },
                            //         { text: i18n.tc('message.complementaryExams', 2), to: { name: 'hospitalisation.complementary-exams' } },
                            //         { text: i18n.t('message.add'), active: true }
                            //     ]
                          },
                        },
                        {
                          path: ":complementary",
                          name: "hospitalisation.complementary-exam",
                          component: () =>
                            import(
                              "../views/Hospitalisations/Exams/Complementary/ComplementaryExam.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title:
                              i18n.tc("message.hospitalisations", 1) +
                              " - " +
                              i18n.tc("message.complementaryExams", 1),
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                            //         { text: i18n.tc('message.hospitalisations', 1), to: { name: 'hospitalisation'} },
                            //         { text: i18n.tc('message.complementaryExams', 2), to: { name: 'hospitalisation.complementary-exams' } },
                            //         { text: i18n.tc('message.complementaryExams', 1), active: true }
                            //     ]
                          },
                        },
                      ],
                    },
                    {
                      path: "reasons",
                      redirect: "hospitalisation-reasons",
                      component: InheritLayout,
                      children: [
                        // {
                        //     path: '',
                        //     name: 'hospitalisation-reasons',
                        //     component: () => import('../views/Hospitalisations/Reasons/Reasons.vue'),
                        //     meta: {
                        //         //requiresAuth: true,
                        //         title: i18n.tc('message.reasons', 2),
                        //         breadcrumbs: [
                        //             { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //             { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //             { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                        //             { text: i18n.tc('message.hospitalisations', 1), to: { name: 'hospitalisation'} },
                        //             { text: i18n.tc('message.reasons', 2), active: true }
                        //         ]
                        //     }
                        // },
                        {
                          path: "add",
                          name: "add-hospitalisation-reason",
                          component: () =>
                            import(
                              "../views/Hospitalisations/Reasons/AddReason.vue"
                            ),
                          meta: {
                            //requiresAuth: true,
                            title: `${i18n.t("message.add")} ${i18n.tc(
                              "message.reasons",
                              1
                            )}`,
                            //     breadcrumbs: [
                            //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                            //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                            //         { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                            //         { text: i18n.tc('message.hospitalisations', 1), to: { name: 'hospitalisation'} },
                            //         //{ text: i18n.tc('message.reasons', 2), to: { name: 'hospitalisation-reasons' } },
                            //         { text: `${i18n.t('message.add')} ${i18n.tc('message.reasons', 1)}`, active: true }
                            //     ]
                          },
                        },
                        // {
                        //     path: ':reason/edit',
                        //     name: 'edit-hospitalisation-reason',
                        //     component: () => import('../views/Hospitalisations/Reasons/EditReason.vue'),
                        //     meta: {
                        //         //requiresAuth: true,
                        //         title: `${i18n.t('message.edit')} ${i18n.tc('message.reasons', 1)}`,
                        //         breadcrumbs: [
                        //             { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //             { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //             { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                        //             { text: i18n.tc('message.hospitalisations', 1), to: { name: 'hospitalisation'} },
                        //             { text: i18n.tc('message.reasons', 2), to: { name: 'hospitalisation-reasons' } },
                        //             { text: i18n.t('message.edit'), active: true }
                        //         ]
                        //     }
                        // },
                        // {
                        //     path: ':reason',
                        //     name: 'hospitalisation-reason',
                        //     component: () => import('../views/Hospitalisations/Reasons/Reason.vue'),
                        //     meta: {
                        //         //requiresAuth: true,
                        //         title: i18n.tc('message.reasons', 1),
                        //         breadcrumbs: [
                        //             { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //             { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //             { text: i18n.tc('message.hospitalisations', 2), to: { name: 'hospitalisations' } },
                        //             { text: i18n.tc('message.hospitalisations', 1), to: { name: 'hospitalisation'} },
                        //             { text: i18n.tc('message.reasons', 2), to: { name: 'hospitalisation-reasons' } },
                        //             { text: i18n.tc('message.reasons', 1), active: true }
                        //         ]
                        //     }
                        // }
                      ],
                    },
                  ],
                },
              ],
            },

            {
              path: "allergies",
              redirect: "allergies",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "allergies",
                  component: () => import("../views/Allergies/Allergies.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.allergies", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.allergies', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: ":file/add-allergy",
                  name: "add-allergy",
                  component: () => import("../views/Allergies/AddAllergy.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addAllergies"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.medicalFiles', 2), to: { name: 'medical-files' } },
                    //         { text: i18n.tc('message.medicalFiles', 1), to: { name: 'medical-file'} },
                    //         //{ text: i18n.tc('message.allergies', 2), to: { name: 'allergies' } },
                    //         { text: `${i18n.t('message.add')} ${i18n.tc('message.allergies', 1)}`, active: true }
                    //     ]
                  },
                },
                {
                  path: ":allergy/edit",
                  name: "edit-allergy",
                  component: () => import("../views/Allergies/EditAllergy.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.allergies", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.allergies', 2), to: { name: 'allergies' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":allergy",
                  name: "allergy",
                  component: () => import("../views/Allergies/Allergy.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.allergies", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.allergies', 2), to: { name: 'allergies' } },
                    //         { text: i18n.tc('message.allergies', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: ":file/antecedents",
              redirect: "antecedents",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "antecedents",
                  component: () =>
                    import("../views/Antecedents/Antecedents.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.antecedents", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.antecedents', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-antecedent",
                  component: () =>
                    import("../views/Antecedents/AddAntecedent.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.t("message.addAntecedent"),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.antecedents', 2), to: { name: 'antecedents' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":antecedent/edit",
                  name: "edit-antecedent",
                  component: () =>
                    import("../views/Antecedents/EditAntecedent.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.antecedents", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.antecedents', 2), to: { name: 'antecedents' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":antecedent",
                  name: "antecedent",
                  component: () =>
                    import("../views/Antecedents/Antecedent.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.antecedents", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.antecedents', 2), to: { name: 'antecedents' } },
                    //         { text: i18n.tc('message.antecedents', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: ":consultation/conclusions",
              redirect: "conclusions",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "conclusions",
                  component: () =>
                    import("../views/Conclusions/Conclusions.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.conclusions", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                    //         // { text: i18n.tc('message.generalConsultations', 1) ,to: { name :'consultation-general', params :{ consultation : '$route.params.consultation'}}},
                    //         { text: i18n.tc('message.conclusions', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "add",
                  name: "add-conclusion",
                  component: () =>
                    import("../views/Conclusions/AddConclusion.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.conclusions", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                    //         // { text: i18n.tc('message.generalConsultations', 1) ,to: { name :'consultation-general', params :{ consultation : '$route.params.consultation'}}},
                    //         { text: i18n.tc('message.conclusions', 2), to: { name: 'conclusions' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":conclusion/edit",
                  name: "edit-conclusion",
                  component: () =>
                    import("../views/Conclusions/EditConclusion.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.conclusions", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                    //         // { text: i18n.tc('message.generalConsultations', 1) ,to: { name :'consultation-general', params :{ consultation : '$route.params.consultation'}}},
                    //         { text: i18n.tc('message.conclusions', 2), to: { name: 'conclusions' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":conclusion",
                  name: "conclusion",
                  component: () =>
                    import("../views/Conclusions/Conclusion.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.conclusions", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                    //         // { text: i18n.tc('message.generalConsultations', 1) ,to: { name :'consultation-general', params :{ consultation : '$route.params.consultation'}}},
                    //         { text: i18n.tc('message.conclusions', 2), to: { name: 'conclusions' } },
                    //         { text: i18n.tc('message.conclusions', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: ":consultation/parameters-common",
              redirect: "parameters-common",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "parameters-common",
                  component: () =>
                    import("../views/Parameters/Commons/Commons.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.commonParameters", 2),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                    //         // { text: i18n.tc('message.generalConsultations', 1) ,to: { name :'consultation-general', params :{ consultation : '$route.params.consultation'}}},
                    //         { text: i18n.tc('message.commonParameters', 2), active: true }
                    //     ]
                  },
                },
                {
                  path: "parametres-commun/add",
                  name: "add-parameter-common",
                  component: () =>
                    import("../views/Parameters/Commons/AddCommon.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.add") +
                      " " +
                      i18n.tc("message.commonParameters", 1),
                    // breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                    //         // { text: i18n.tc('message.generalConsultations', 1) ,to: { name :'consultation-general', params :{ consultation : this.$route.params.consultation}}},
                    //         { text: i18n.tc('message.commonParameters', 2), to: { name: 'parameters-common' } },
                    //         { text: i18n.t('message.add'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":parameter/edit",
                  name: "edit-parameter-common",
                  component: () =>
                    import("../views/Parameters/Commons/EditCommon.vue"),
                  meta: {
                    //requiresAuth: true,
                    title:
                      i18n.t("message.edit") +
                      " " +
                      i18n.tc("message.commonParameters", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.consultations', 2), to: { name: 'consultations' } },
                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                    //         // { text: i18n.tc('message.generalConsultations', 1) ,to: { name :'consultation-general', params :{ consultation : '$route.params.consultation'}}},
                    //         { text: i18n.tc('message.commonParameters', 2), to: { name: 'parameters-common' } },
                    //         { text: i18n.t('message.edit'), active: true }
                    //     ]
                  },
                },
                {
                  path: ":parameter",
                  name: "parameter-common",
                  component: () =>
                    import("../views/Parameters/Commons/Common.vue"),
                  meta: {
                    //requiresAuth: true,
                    title: i18n.tc("message.commonParameters", 1),
                    //     breadcrumbs: [
                    //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                    //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                    //         { text: i18n.tc('message.generalConsultations', 2), to: { name: 'consultations-generals' } },
                    //         { text: i18n.tc('message.generalConsultations', 1) ,to: { name :'consultation-general', params :{ consultation : '$route.params.consultation'}}},
                    //         { text: i18n.tc('message.commonParameters', 2), to: { name: 'parameters-common' } },
                    //         { text: i18n.tc('message.commonParameters', 1), active: true }
                    //     ]
                  },
                },
              ],
            },
            {
              path: "results",
              redirect: "results",
              component: InheritLayout,
              children: [
                {
                  path: "lab",
                  redirect: "lab-results",
                  component: InheritLayout,
                  children: [
                    {
                      path: "",
                      name: "lab-results",
                      component: () =>
                        import("../views/Resultats/Labo/Resultats.vue"),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.tc("message.labResults", 2),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.tc('message.labResults', 2), active: true }
                        //     ]
                      },
                    },
                    {
                      path: ":file/add",
                      name: "add-lab-result",
                      component: () =>
                        import("../views/Resultats/Labo/AddResultat.vue"),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.t("message.addLabResults"),
                        // breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.tc('message.labResults', 2), to: { name: 'lab-results' } },
                        //         { text: i18n.t('message.add'), active: true }
                        //     ]
                      },
                    },
                    {
                      path: ":result/edit",
                      name: "edit-lab-result",
                      component: () =>
                        import("../views/Resultats/Labo/EditResultat.vue"),
                      meta: {
                        //requiresAuth: true,
                        title:
                          i18n.t("message.edit") +
                          " " +
                          i18n.tc("message.labResults", 1),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.tc('message.labResults', 2), to: { name: 'lab-results' } },
                        //         { text: i18n.t('message.edit'), active: true }
                        //     ]
                      },
                    },
                    {
                      path: ":result",
                      name: "lab-result",
                      component: () =>
                        import("../views/Resultats/Labo/Resultat.vue"),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.tc("message.labResults", 1),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.tc('message.labResults', 2), to: { name: 'lab-results' } },
                        //         { text: i18n.tc('message.labResults', 1), active: true }
                        //     ]
                      },
                    },
                  ],
                },
                {
                  path: "imagery",
                  redirect: "imagery-results",
                  component: InheritLayout,
                  children: [
                    {
                      path: "",
                      name: "imagery-results",
                      component: () =>
                        import("../views/Resultats/Imagerie/Resultats.vue"),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.tc("message.imageryResults", 2),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.tc('message.imageryResults', 2), active: true }
                        //     ]
                      },
                    },
                    {
                      path: ":file/add",
                      name: "add-imagery-result",
                      component: () =>
                        import("../views/Resultats/Imagerie/AddResultat.vue"),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.t("message.addImageryRes"),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.tc('message.imageryResults', 2), to: { name: 'imagery-results' } },
                        //         { text: i18n.t('message.add'), active: true }
                        //     ]
                      },
                    },
                    {
                      path: ":result/edit",
                      name: "edit-imagery-result",
                      component: () =>
                        import("../views/Resultats/Imagerie/EditResultat.vue"),
                      meta: {
                        //requiresAuth: true,
                        title:
                          i18n.t("message.edit") +
                          " " +
                          i18n.tc("message.imageryResults", 1),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.tc('message.imageryResults', 2), to: { name: 'imagery-results' } },
                        //         { text: i18n.t('message.edit'), active: true }
                        //     ]
                      },
                    },
                    {
                      path: ":result",
                      name: "imagery-result",
                      component: () =>
                        import("../views/Resultats/Imagerie/Resultat.vue"),
                      meta: {
                        //requiresAuth: true,
                        title: i18n.tc("message.imageryResults", 1),
                        //     breadcrumbs: [
                        //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                        //         { text: i18n.t('message.medicalManagement'), to: { name: 'medical-management' } },
                        //         { text: i18n.tc('message.imageryResults', 2), to: { name: 'imagery-results' } },
                        //         { text: i18n.tc('message.imageryResults', 1), active: true }
                        //     ]
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: "/payment-management",
          name: "payment-management",
          component: AdminLayout,
          children: [
            {
              path: "",
              name: "payment-management",
              component: () => import("../views/Payment/PaymentManagement.vue"),
              meta: {
                title: i18n.tc("message.paymentManagement", 1),
              },
            },
            {
              path: "cim",
              name: "payment-cim",
              component: () => import("../views/Payment/Cim.vue"),
              meta: {
                title: i18n.tc("message.paymentCim", 1),
              },
            },
            {
              path: "medicasure",
              name: "payment-medicasure",
              component: () => import("../views/Payment/Medicasure.vue"),
              meta: {
                title: i18n.tc("message.paymentMedicasure", 1),
              },
            },
            {
              path: "/pay-prestation",
              name: "pay-prestation",
              component: InheritLayout,
              children: [
                {
                  path: "",
                  name: "pay-prestation",
                  component: () => import("../views/Payment/List.vue"),
                  meta: {
                    title: i18n.tc("message.payment", 1),
                  },
                },
                {
                  path: "add",
                  name: "add-pay-prestation",
                  component: () => import("../views/Payment/Add.vue"),
                  meta: {
                    title: i18n.tc("message.paymentPrestation", 1),
                  },
                },
                {
                  path: "show/:id",
                  name: "show-pay-prestation",
                  component: () => import("../views/Payment/Show.vue"),
                  meta: {
                    title: i18n.tc("message.payment", 1),
                  },
                },
                {
                  path: "edit/:id",
                  name: "edit-pay-prestation",
                  component: () => import("../views/Payment/Edit.vue"),
                  meta: {
                    title: i18n.tc("message.Editpayment", 1),
                  },
                },
              ],
            },
          ],
        },

        {
          path: "file-manager",
          redirect: "file-manager",
          component: AdminLayout,
          children: [
            {
              path: "",
              name: "file-manager",
              component: () =>
                import(
                  /* webpackChunkName: "demo" */ "../views/FileManager/FileManager.vue"
                ),
              meta: {
                //requiresAuth: true,
                title: i18n.tc("message.imageryResults", 1),
                //     breadcrumbs: [
                //         { text: i18n.t('message.dashboard'), to: { name: localStorage.getItem('dashboardName')  } },
                //         { text: i18n.t('message.fileManager'), active: true }
                //     ]
              },
            },
          ],
        },
        {
          path: "/icons",
          name: "icons",
          component: () =>
            import(/* webpackChunkName: "demo" */ "../views/Icons.vue"),
        },
        {
          path: "/profile",
          name: "profile",
          component: () =>
            import(/* webpackChunkName: "demo" */ "../views/UserProfile.vue"),
        },
        {
          path: "/maps",
          name: "maps",
          component: () =>
            import(/* webpackChunkName: "demo" */ "../views/Maps.vue"),
        },
        {
          path: "/tables",
          name: "tables",
          component: () =>
            import(/* webpackChunkName: "demo" */ "../views/Tables.vue"),
        },
        {
          path: "mobile",
          redirect: "mobile",
          component: AdminLayout,

          children: [
            {
              path: "/",

              name: "mobile",
              component: () => import("../views/MedsurlinkMobile.vue"),
              meta: {
                //requiresAuth: true,
                title: "Medsurlink Mobile",
              },
            },
            {
              path: "/mobile/metriques",
              name: "metriques",
              component: () =>
                import("../views/Medsurlink-Mobile/Metriques.vue"),
            },
            {
              path: "/mobile/metriques/detail/:type_input",
              name: "metrique-detail",
              component: () => import("../views/Medsurlink-Mobile/Detail.vue"),
             
            },
            {
              path: "/mobile/prestataires",
              name: "prestataires",
              component: () =>
                import("../views/Medsurlink-Mobile/Prestataires.vue"),
            },
            {
              path: "/mobile/etablissements",
              name: "etablissements",
              component: () =>
                import("../views/Medsurlink-Mobile/Etablissements.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "/",
      redirect: "login",
      component: AuthLayout,
      children: [
        {
          path: "/landing",
          name: "landing",
          component: () =>
            import(/* webpackChunkName: "demo" */ "../views/Landing.vue"),
        },
        {
          path: "/success",
          name: "success",
          component: () =>
            import(/* webpackChunkName: "demo" */ "../views/Success.vue"),
        },
        {
          path: "/error",
          name: "error",
          component: () => import("../views/Paiement/PaiementError.vue"),
        },
        {
          path: "/login",
          name: "login",
          component: () =>
            import(/* webpackChunkName: "demo" */ "../views/Login.vue"),
        },
        {
          path: "/email",
          name: "email",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "../views/Passwords/Email.vue"
            ),
        },
        {
          path: "/password/reset/:token/:user",
          name: "reset",
          component: () =>
            import(
              /* webpackChunkName: "demo" */ "../views/Passwords/Reset.vue"
            ),
        },
        {
          path: "/register",
          name: "register",
          component: () =>
            import(/* webpackChunkName: "demo" */ "../views/Register.vue"),
        },
      ],
    },

    {
      path: "/contrat-prepaye",
      redirect: "add",
      component: AuthLayout,
      children: [
        {
          path: "add",
          name: "contrat-prepaye",
          component: () => import("../views/Landing.vue"),
          meta: {
            title: i18n.t("message.add") + " " + i18n.tc("message.patients", 1),
          },
        },
      ],
    },
    {
      path: "/souscripteur-profile",
      redirect: "checkout",
      component: DashboardLayout,
      children: [
        {
          path: "complete",
          name: "user-profile",
          component: () => import("../views/UserProfile.vue"),
          meta: {
            // title: i18n.t('message.add') + ' ' + i18n.tc('message.patients', 1),
          },
        },
        {
          path: "/checkout",
          name: "checkout",
          component: () => import("../views/Paiement/Checkout.vue"),
          meta: {
            // title: i18n.t('message.add') + ' ' + i18n.tc('message.patients', 1),
          },
        },

        {
          path: "om/paiement/:identifiant/:pay_token/notification",
          name: "om-notification",
          component: () => import("../views/Paiement/OMNotification.vue"),
          meta: {
            //  title: i18n.t('message.add') + ' ' + i18n.tc('message.notification', 1),
          },
        },
        {
          path: "uba-paiement/:code/:status",
          name: "uba-notification",
          component: () => import("../views/Paiement/UbaNotification.vue"),
          meta: {
            // title: i18n.t('message.add') + ' ' + i18n.tc('message.notification', 1),
          },
        },
        {
          path: "Momo/paiement/:identifiant/:reference",
          name: "momo-notification",
          component: () => import("../views/Paiement/MomoNotification.vue"),
          meta: {
            // title: i18n.t('message.add') + ' ' + i18n.tc('message.notification', 1),
          },
        },
      ],
    },
    // {
    //     path:'/trajet-dashboard',
    //     redirect: 'TrajetDashbord',
    //     component: DashboardLayout,
    //     children: [
    //         {
    //             path: '/',
    //             name: 'TrajetDashbord',
    //             component: () => import('../views/Dashboard/TrajetPatientDashboard.vue'),
    //             meta: {
    //                 //requiresAuth: true,
    //                 title: i18n.t('message.TrajetPatient'),
    //                 //     breadcrumbs: [
    //                 //         { text: i18n.t('message.dashboard'), active: true }
    //                 //     ]
    //             }
    //         },
    //     ]
    // },
    {
      path: "/practioner-dashboard",
      name: "PractionerDashboard",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(
          /* webpackChunkName: "demo" */ "../views/Dashboard/PractionerDashboard.vue"
        ),
      meta: {
        //requiresAuth: true,
        title: i18n.t("message.practionerDashboard"),
        //     breadcrumbs: [
        //         { text: i18n.t('message.practionerDashboard'), active: true }
        //     ]
      },
    },
    {
      path: "/trajet-dashboard",
      redirect: "TrajetDashboard",
      component: DashboardLayout,
      children: [
        {
          path: "/trajet-dashboard",
          name: "TrajetDashboard",
          component: () => import("../views/Dashboard/TrajetDashboard.vue"),
          meta: {
            //requiresAuth: true,
            title: i18n.t("message.Trajet"),
            //     breadcrumbs: [
            //         { text: i18n.t('message.practionerDashboard'), active: true }
            //     ]
          },
        },
      ],
    },
    {
      path: "/rgbac",
      redirect: "gestion-des-rgbac",
      component: DashboardLayout,
      children: [
        {
          path: "/",
          name: "gestion-des-rgbac",
          component: () => import("../views/Rgbac/index.vue"),
          meta: {
            title: "gestion des RGBAC",
          },
        },
        {
          path: "/rgbac/roles",
          name: "roles",
          component: () => import("../views/Rgbac/roles.vue"),
          meta: {
            title: "Roles",
          },
        },
        {
          path: "/rgbac/permissions",
          name: "permissions",
          component: () => import("../views/Rgbac/permissions.vue"),
          meta: {
            title: "Permissions",
          },
        },
        {
          path: "/rgbac/roles/:id",
          name: "view-role-details",
          component: () => import("../views/Rgbac/role.vue"),
          meta: {
            title: "Permissions",
          },
        },
        {
          path: "/rgbac/user-permissions",
          name: "user-permissions",
          component: () => import("../views/Rgbac/userPermissions.vue"),
          meta: {
            title: "Permissions utilisateur",
          },
        },
        {
          path: "/rgbac/user-permissions/:id",
          name: "view-users-details",
          component: () => import("../views/Rgbac/userDetails.vue"),
          meta: {
            title: "details utilisateur",
          },
        },

        //
      ],
    },
  ],
});
/*
router.beforeEach((to, from, next) => {

    if (to.name == 'contrat-prepaye' ){
        var token = to.query.token
        var status = to.query.status
        console.log(to.query);
        if(status!="success")
        next({ name: 'login' })
        else{
        var res = token.split("medsur");
        var password = res[0];
        var email = res[1];
        let args = {
            grant_type: 'password',
            client_id: AppConfig.appClientId,
            client_secret: AppConfig.appClientSecret,
            username: email,
            password: password
        };
        console.log(args);
        store.dispatch('loginHandler', { args });
        }
    } 
    //else next()
   else{
    // console.log(to.name);
   }
  })*/

export default router;
